export const cats = {
    "$FOCA$BL$$": "Bank Loan",
    "$FOCA$BM$$": "Bear Market",
    "$FOCA$CA$$": "Allocation--30% to 50% Equity",
    "$FOCA$CI$$": "Intermediate Core Bond",
    "$FOCA$CL$$": "Long-Term Bond",
    "$FOCA$CS$$": "Short-Term Bond",
    "$FOCA$CV$$": "Convertibles",
    "$FOCA$DP$$": "Diversified Pacific/Asia",
    "$FOCA$EB$$": "Emerging Markets Bond",
    "$FOCA$EM$$": "Diversified Emerging Mkts",
    "$FOCA$ES$$": "Europe Stock",
    "$FOCA$FA$$": "Foreign Small/Mid Value",
    "$FOCA$FB$$": "Foreign Large Blend",
    "$FOCA$FG$$": "Foreign Large Growth",
    "$FOCA$FR$$": "Foreign Small/Mid Growth",
    "$FOCA$FV$$": "Foreign Large Value",
    "$FOCA$GI$$": "Intermediate Government",
    "$FOCA$GL$$": "Long Government",
    "$FOCA$GS$$": "Short Government",
    "$FOCA$HM$$": "High Yield Muni",
    "$FOCA$HY$$": "High Yield Bond",
    "$FOCA$IB$$": "World Bond",
    "$FOCA$IH$$": "World Allocation",
    "$FOCA$IP$$": "Inflation-Protected Bond",
    "$FOCA$JS$$": "Japan Stock",
    "$FOCA$LB$$": "Large Blend",
    "$FOCA$LG$$": "Large Growth",
    "$FOCA$LO$$": "Long-Short Equity",
    "$FOCA$LS$$": "Latin America Stock",
    "$FOCA$LV$$": "Large Value",
    "$FOCA$MA$$": "Allocation--50% to 70% Equity",
    "$FOCA$MB$$": "Mid-Cap Blend",
    "$FOCA$MC$$": "Muni California Long",
    "$FOCA$MF$$": "Muni California Intermediate",
    "$FOCA$MG$$": "Mid-Cap Growth",
    "$FOCA$MI$$": "Muni National Interm",
    "$FOCA$MJ$$": "Muni New Jersey",
    "$FOCA$ML$$": "Muni National Long",
    "$FOCA$MN$$": "Muni New York Intermediate",
    "$FOCA$MO$$": "Muni Ohio",
    "$FOCA$MP$$": "Muni Pennsylvania",
    "$FOCA$MS$$": "Muni National Short",
    "$FOCA$MT$$": "Muni Massachusetts",
    "$FOCA$MU$$": "Multisector Bond",
    "$FOCA$MV$$": "Mid-Cap Value",
    "$FOCA$MY$$": "Muni New York Long",
    "$FOCA$PJ$$": "Pacific/Asia ex-Japan Stk",
    "$FOCA$SB$$": "Small Blend",
    "$FOCA$SC$$": "Communications",
    "$FOCA$SF$$": "Financial",
    "$FOCA$SG$$": "Small Growth",
    "$FOCA$SH$$": "Health",
    "$FOCA$SI$$": "Muni Single State Interm",
    "$FOCA$SL$$": "Muni Single State Long",
    "$FOCA$SM$$": "Muni Minnesota",
    "$FOCA$SN$$": "Natural Resources",
    "$FOCA$SP$$": "Equity Precious Metals",
    "$FOCA$SR$$": "Real Estate",
    "$FOCA$SS$$": "Muni Single State Short",
    "$FOCA$ST$$": "Technology",
    "$FOCA$SU$$": "Utilities",
    "$FOCA$SV$$": "Small Value",
    "$FOCA$TA$$": "Target-Date 2000-2010",
    "$FOCA$TF$$": "Money Market-Tax-Free",
    "$FOCA$TM$$": "Money Market-Taxable",
    "$FOCA$UB$$": "Ultrashort Bond",
    "$FOCA$VL$$": "Stable Value",
    "$FOCA$WS$$": "World Large Stock",
    "AUCA000005": "Alternative Strategies",
    "AUCA000007": "Bonds - Australia",
    "AUCA000008": "Equity Emerging Markets",
    "AUCA000009": "Equity Asia Pacific w/o Japan",
    "AUCA000010": "Equity Australia Other",
    "AUCA000011": "Equity Australia Large Blend",
    "AUCA000012": "Equity Australia Large Geared",
    "AUCA000013": "Equity Australia Large Growth",
    "AUCA000014": "Equity Australia Large Value",
    "AUCA000015": "Equity Australia Mid/Small Blend",
    "AUCA000016": "Equity Australia Mid/Small Growth",
    "AUCA000017": "Equity Australia Mid/Small Value",
    "AUCA000018": "Equity Europe",
    "AUCA000019": "Equity Japan",
    "AUCA000020": "Equity North America",
    "AUCA000022": "Equity Australia Real Estate",
    "AUCA000023": "Equity Global Real Estate",
    "AUCA000024": "Equity Global Technology",
    "AUCA000026": "Equity World Other",
    "AUCA000027": "Equity World Large Blend",
    "AUCA000028": "Equity World Large Growth",
    "AUCA000029": "Equity World Large Value",
    "AUCA000030": "Equity World Mid/Small",
    "AUCA000033": "Bonds - Global",
    "AUCA000035": "Miscellaneous",
    "AUCA000036": "Mortgages",
    "AUCA000037": "Multisector Aggressive",
    "AUCA000038": "Multisector Balanced",
    "AUCA000039": "Multisector Conservative",
    "AUCA000040": "Multisector Growth",
    "AUCA000041": "Multisector Moderate",
    "AUCA000042": "Reserve Backed",
    "AUCA000043": "Australian Cash",
    "AUCA000044": "Australian Short Term Fixed Interest",
    "AUCA000045": "High Yield Credit",
    "AUCA000046": "Unlisted and Direct Property",
    "AUCA000048": "Bonds - Global / Australia",
    "AUCA000050": "Infrastructure - Global",
    "CACA000003": "Asia Pacific ex-Japan Equity",
    "CACA000005": "Asia Pacific Equity",
    "CACA000009": "Canadian Fixed Income",
    "CACA000013": "Canadian Equity",
    "CACA000015": "Canadian Focused Equity",
    "CACA000019": "Canadian Money Market",
    "CACA000025": "Canadian Short Term Fixed Income",
    "CACA000029": "Emerging Markets Equity",
    "CACA000031": "European Equity",
    "CACA000035": "Financial Services Equity",
    "CACA000039": "Global Equity",
    "CACA000043": "High Yield Fixed Income",
    "CACA000045": "International Equity",
    "CACA000053": "Natural Resources Equity",
    "CACA000057": "Precious Metals Equity",
    "CACA000059": "Real Estate Equity",
    "CACA000063": "Miscellaneous - Other",
    "CACA000065": "US Equity",
    "CACA000067": "US Money Market",
    "CACA000069": "US Small/Mid Cap Equity",
    "CACA000113": "Canadian Focused Small/Mid Cap Equity",
    "CACA000114": "Canadian Equity Balanced",
    "CACA000115": "Canadian Fixed Income Balanced",
    "CACA000116": "Canadian Dividend and Income Equity",
    "CACA000117": "Canadian Inflation Protected Fixed Income",
    "CACA000118": "Canadian Long Term Fixed Income",
    "CACA000119": "Canadian Neutral Balanced",
    "CACA000120": "Canadian Small/Mid Cap Equity",
    "CACA000121": "North American Equity",
    "CACA000132": "Global Equity Balanced",
    "CACA000133": "Global Fixed Income",
    "CACA000134": "Global Fixed Income Balanced",
    "CACA000136": "Global Neutral Balanced",
    "CACA000137": "Global Small/Mid Cap Equity",
    "CACA000142": "Retail Venture Capital",
    "EUCA000500": "Greater China Equity",
    "EUCA000501": "Asia-Pacific ex-Japan Equity",
    "EUCA000502": "Asia-Pacific inc. Japan Equity",
    "EUCA000503": "Australia & New Zealand Equity",
    "EUCA000504": "China Equity",
    "EUCA000505": "Denmark Equity",
    "EUCA000507": "Global Emerging Markets Equity",
    "EUCA000508": "Emerging Europe Equity",
    "EUCA000509": "Europe ex-UK Large-Cap Equity",
    "EUCA000510": "Europe ex-UK Small/Mid-Cap Equity",
    "EUCA000511": "Europe Large-Cap Blend Equity",
    "EUCA000512": "Europe Large-Cap Growth Equity",
    "EUCA000513": "Europe Large-Cap Value Equity",
    "EUCA000514": "Europe Flex-Cap Equity",
    "EUCA000515": "Europe Small-Cap Equity",
    "EUCA000516": "Eurozone Large-Cap Equity",
    "EUCA000517": "Eurozone Flex-Cap Equity",
    "EUCA000518": "Eurozone Small-Cap Equity",
    "EUCA000519": "Hong Kong Equity",
    "EUCA000520": "India Equity",
    "EUCA000521": "Japan Large-Cap Equity",
    "EUCA000522": "Japan Small/Mid-Cap Equity",
    "EUCA000523": "Korea Equity",
    "EUCA000524": "Latin America Equity",
    "EUCA000525": "Nordic Equity",
    "EUCA000526": "US Large-Cap Blend Equity",
    "EUCA000527": "US Large-Cap Growth Equity",
    "EUCA000528": "US Large-Cap Value Equity",
    "EUCA000529": "US Flex-Cap Equity",
    "EUCA000530": "US Small-Cap Equity",
    "EUCA000531": "Norway Equity",
    "EUCA000532": "Sector Equity Biotechnology",
    "EUCA000533": "Sector Equity Communications",
    "EUCA000534": "Sector Equity Consumer Goods & Services",
    "EUCA000535": "Sector Equity Energy",
    "EUCA000536": "Sector Equity Financial Services",
    "EUCA000537": "Sector Equity Healthcare",
    "EUCA000538": "Sector Equity Industrial Materials",
    "EUCA000539": "Other Equity",
    "EUCA000540": "Property - Direct Other",
    "EUCA000541": "Property - Indirect Global",
    "EUCA000542": "Sector Equity Technology",
    "EUCA000543": "Sector Equity Utilities",
    "EUCA000544": "Singapore Equity",
    "EUCA000545": "Sweden Equity",
    "EUCA000546": "Sweden Small/Mid-Cap Equity",
    "EUCA000547": "Sweden/Global Equity",
    "EUCA000548": "Switzerland Large-Cap Equity",
    "EUCA000550": "UK Large-Cap Equity",
    "EUCA000553": "UK Flex-Cap Equity",
    "EUCA000554": "UK Small-Cap Equity",
    "EUCA000555": "Global Large-Cap Blend Equity",
    "EUCA000556": "Global Large-Cap Growth Equity",
    "EUCA000557": "Global Large-Cap Value Equity",
    "EUCA000558": "Global Flex-Cap Equity",
    "EUCA000559": "Asia Allocation",
    "EUCA000563": "EUR Aggressive Allocation - Global",
    "EUCA000564": "EUR Cautious Allocation - Global",
    "EUCA000565": "EUR Moderate Allocation - Global",
    "EUCA000566": "NOK Moderate Allocation",
    "EUCA000570": "Asia Bond",
    "EUCA000573": "CHF Bond",
    "EUCA000574": "Global Bond - CHF Biased",
    "EUCA000575": "CHF Money Market",
    "EUCA000576": "DKK Bond",
    "EUCA000579": "DKK Bond - Short Term",
    "EUCA000580": "USD Diversified Bond",
    "EUCA000581": "Global Bond - USD Biased",
    "EUCA000582": "USD Government Bond",
    "EUCA000583": "USD High Yield Bond",
    "EUCA000584": "USD Money Market",
    "EUCA000585": "USD Diversified Bond - Short Term",
    "EUCA000586": "Global Emerging Markets Bond",
    "EUCA000587": "EUR Diversified Bond",
    "EUCA000588": "Global Bond - EUR Biased",
    "EUCA000589": "EUR Government Bond",
    "EUCA000590": "EUR High Yield Bond",
    "EUCA000591": "EUR Money Market",
    "EUCA000592": "EUR Ultra Short-Term Bond",
    "EUCA000593": "EUR Diversified Bond - Short Term",
    "EUCA000594": "Europe Bond",
    "EUCA000595": "JPY Bond",
    "EUCA000596": "NOK Bond",
    "EUCA000598": "NOK Ultra Short-Term Bond",
    "EUCA000599": "NOK Bond - Short Term",
    "EUCA000600": "SEK Bond",
    "EUCA000602": "SEK Ultra Short-Term Bond",
    "EUCA000603": "SEK Bond - Short Term",
    "EUCA000604": "GBP Diversified Bond",
    "EUCA000605": "Global Bond - GBP Biased",
    "EUCA000606": "GBP Government Bond",
    "EUCA000607": "GBP High Yield Bond",
    "EUCA000608": "GBP Money Market",
    "EUCA000611": "Guaranteed Funds",
    "EUCA000615": "Capital Protected",
    "EUCA000616": "SEK Aggressive Allocation",
    "EUCA000617": "SEK Cautious Allocation",
    "EUCA000618": "CHF Aggressive Allocation",
    "EUCA000619": "CHF Cautious Allocation",
    "EUCA000620": "GBP Adventurous Allocation",
    "EUCA000621": "GBP Cautious Allocation",
    "EUCA000622": "EUR Bond - Long Term",
    "EUCA000623": "Emerging Europe Bond",
    "EUCA000624": "Global Bond - EUR Hedged",
    "EUCA000625": "EUR Inflation-Linked Bond",
    "EUCA000630": "Austria Equity",
    "EUCA000631": "Belgium Equity",
    "EUCA000632": "Canada Equity",
    "EUCA000633": "Emerging Europe ex-Russia Equity",
    "EUCA000635": "Finland Equity",
    "EUCA000636": "France Large-Cap Equity",
    "EUCA000637": "France Small/Mid-Cap Equity",
    "EUCA000638": "Germany Large-Cap Equity",
    "EUCA000639": "Germany Small/Mid-Cap Equity",
    "EUCA000640": "Italy Equity",
    "EUCA000641": "Netherlands Equity",
    "EUCA000642": "Russia Equity",
    "EUCA000643": "Spain Equity",
    "EUCA000644": "Switzerland Small/Mid-Cap Equity",
    "EUCA000646": "Sector Equity Precious Metals",
    "EUCA000999": "Other",
    "INCA000001": "Large-Cap",
    "INCA000002": "Mid-Cap",
    "INCA000003": "Sector - Healthcare",
    "INCA000004": "Sector - Technology",
    "INCA000006": "Short Duration",
    "INCA000007": "Ultra Short Duration",
    "INCA000008": "10 yr Government Bond",
    "INCA000009": "Government Bond",
    "INCA000010": "Short-Term Government Bond",
    "INCA000011": "Liquid",
    "INCA000012": "Balanced Allocation",
    "INCA000013": "Conservative Allocation",
    "INCA000016": "Fixed Maturity Short-Term Bond",
    "INCA000017": "Fixed Maturity Ultrashort Bond",
    "PGSZ01TTTT": "Equity Funds",
    "PGSZ04TTTT": "Money Market Fund",
    "PGSZ05TTTT": "Guaranteed Fund",
    "PGSZA2TTTT": "Normal Bond Fund",
    "PGSZA3TTTT": "Moderate Allocation Fund",
    "PGSZB2TTTT": "Short-Term Bond Fund",
    "PGSZB3TTTT": "Conservative Allocation Fund",
    "EUCA000669": "ASEAN Equity",
    "JPCA000032": "Australia & New Zealand Bond",
    "JPCA000019": "Asia/Pacific Equity",
    "JPCA000050": "Aggressive Allocation",
    "JPCA000048": "Conservative Allocation",
    "JPCA000049": "Moderate Allocation",
    "MXCA000014": "Other Debt",
    "JPCA000044": "Commodity",
    "$FOCA$CR$$": "Multicurrency",
    "JPCA000055": "Trading - Leveraged/Inverse Bond",
    "JPCA000056": "Trading - Leveraged/Inverse Currency",
    "JPCA000054": "Trading - Leveraged/Inverse Equity",
    "EUCA000693": "USD Aggressive Allocation",
    "EUCA000695": "USD Cautious Allocation",
    "EUCA000691": "USD Corporate Bond",
    "EUCA000694": "USD Moderate Allocation",
    "MXCA000005": "Emerging Market Equity",
    "JPCA000034": "Emerging Global Bond",
    "JPCA000022": "Emerging Multiple Country/Area Equity",
    "EUCA000651": "Emerging Markets Equity PP",
    "JPCA000021": "Emerging Specific Country/Area Equity",
    "NZCA000017": "Equity Region Asia Pacific Non-PIE",
    "NZCA000021": "Equity Region Australasia Non-PIE",
    "NZCA000016": "Equity Region Australia Non-PIE",
    "NZCA000018": "Equity Region Emerging Markets Non-PIE",
    "NZCA000019": "Equity Region Europe Non-PIE",
    "NZCA000020": "Equity Region North America Non-PIE",
    "NZCA000008": "Equity Region NZ Non-PIE",
    "NZCA000013": "Equity Region World Non-PIE",
    "NZCA000015": "Equity Sector Global - Real Estate Non-PIE",
    "NZCA000009": "Equity Sector NZ - Passive Non-PIE",
    "NZCA000010": "Equity Sector NZ - Real Estate Non-PIE",
    "NZCA000014": "Equity Sector World Passive Non-PIE",
    "EUCA000652": "Euro Aggressive Balanced PP",
    "EUCA000653": "Euro Cautious Balanced PP",
    "EUCA000690": "EUR Corporate Bond",
    "EUCA000654": "Euro Diversified Bond PP",
    "EUCA000656": "Euro Moderate Balanced PP",
    "EUCA000657": "Euro Money Market PP",
    "EUCA000658": "Euro Short Bond PP",
    "JPCA000031": "Europe Bond",
    "JPCA000016": "Europe Equity",
    "EUCA000659": "Europe Equity PP",
    "EUCA000660": "Eurozone Equity PP",
    "MXCA000003": "Global Equity",
    "EUCA000661": "Global Equity PP",
    "$FOCA$GR$$": "Global Real Estate",
    "CACA000150": "Greater China Equity",
    "JPCA000017": "Greater China Equity",
    "EUCA000662": "Guaranteed PP",
    "JPCA000045": "Alt-Long/Short",
    "JPCA000046": "Alt-Market Neutral",
    "JPCA000047": "Alt - Multistrategy",
    "JPCA000018": "India Equity",
    "EUCA000681": "Islamic Allocation - Other",
    "EUCA000680": "Islamic Global Bond",
    "EUCA000673": "Islamic Equity - Other",
    "JPCA000023": "Japan Bond Long/Intermediate",
    "JPCA000024": "Japan Bond Short-Term",
    "JPCA000002": "Japan Large-Cap Blend Equity",
    "JPCA000003": "Japan Large-Cap Growth Equity",
    "JPCA000001": "Japan Large-Cap Value Equity",
    "EUCA000664": "Japan Equity PP",
    "JPCA000057": "Japan Money Market",
    "JPCA000040": "Japan REIT",
    "$FOCA$LN$$": "Leveraged Net Long",
    "$FOCA$NE$$": "Market Neutral",
    "MXCA000009": "MXN Aggressive Allocation",
    "MXCA000007": "MXN Cautious Allocation",
    "MXCA000008": "MXN Moderate Allocation",
    "MXCA000001": "Mexico Equity",
    "MXCA000012": "Money Market MXN",
    "NZCA000001": "Miscellaneous Non-PIE",
    "NZCA000033": "Mortgages GIF",
    "NZCA000032": "Mortgages Non-PIE",
    "NZCA000006": "Multisector - Aggressive Non-PIE",
    "NZCA000004": "Multisector - Balanced Non-PIE",
    "NZCA000002": "Multisector - Conservative Non-PIE",
    "NZCA000005": "Multisector - Growth Non-PIE",
    "NZCA000003": "Multisector - Moderate Non-PIE",
    "EUCA000696": "Portugal Equity",
    "PGSZ0BTTTT": "QDII Fund",
    "EUCA000687": "Property - Indirect Asia",
    "EUCA000688": "Property - Indirect Europe",
    "EUCA000668": "Sector Real Estate PP",
    "EUCA000666": "Spain Equity PP",
    "NZCA000031": "Cash GIF",
    "NZCA000025": "NZ Bonds GIF",
    "NZCA000023": "NZ Bonds Non-PIE",
    "NZCA000030": "Cash Non-PIE",
    "NZCA000027": "Global Bond Non-PIE",
    "NZCA000028": "Global Bonds GIF",
    "EUCA000692": "GBP Corporate Bond",
    "JPCA000051": "Tactical Allocation",
    "CACA000148": "Tactical Balanced",
    "EUCA000670": "Taiwan Large-Cap Equity",
    "EUCA000671": "Taiwan Small/Mid-Cap Equity",
    "JPCA000052": "Target Date 2030 and earlier",
    "EUCA000683": "TWD Aggressive Allocation",
    "EUCA000684": "TWD Cautious Allocation",
    "EUCA000674": "TWD Money Market",
    "JPCA000030": "North America Bond",
    "JPCA000015": "North America Equity",
    "NZCA000040": "Unlisted and Direct Property - NZ Non-PIE",
    "MXCA000004": "US Equity",
    "EUCA000665": "USA Equity PP",
    "JPCA000028": "World Bond",
    "JPCA000037": "World Convertible Bond",
    "JPCA000013": "World Equity",
    "JPCA000029": "World ex-Japan Bond",
    "JPCA000014": "World ex-Japan Equity",
    "JPCA000033": "World High Yield Bond Global",
    "JPCA000041": "World REIT",
    "JPCA000038": "World ST Bond/Money",
    "AUCA000051": "Diversified Credit",
    "AUCA000052": "Mortgages Aggressive",
    "AUCA000053": "Multi-Strategy Income",
    "EUCA000697": "Africa Equity",
    "EUCA000698": "Africa & Middle East Equity",
    "EUCA000699": "Brazil Equity",
    "EUCA000700": "BRIC Equity",
    "EUCA000701": "Greece Equity",
    "EUCA000702": "Poland Equity",
    "EUCA000703": "Turkey Equity",
    "EUCA000704": "Sector Equity Natural Resources",
    "EUCA000705": "Sector Equity Alternative Energy",
    "EUCA000706": "Sector Equity Ecology",
    "EUCA000707": "Sector Equity Infrastructure",
    "EUCA000708": "Sector Equity Private Equity",
    "$FOCA$AA$$": "Commodities Agriculture",
    "$FOCA$BB$$": "Commodities Broad Basket",
    "$FOCA$CC$$": "Consumer Defensive",
    "$FOCA$CD$$": "Consumer Cyclical",
    "$FOCA$CE$$": "Commodities Energy",
    "$FOCA$CP$$": "Commodities Precious Metals",
    "$FOCA$EE$$": "Equity Energy",
    "$FOCA$ID$$": "Industrials",
    "$FOCA$IM$$": "Commodities Industrial Metals",
    "$FOCA$MR$$": "Miscellaneous Sector",
    "$FOCA$RI$$": "Target-Date Retirement",
    "$FOCA$TD$$": "Target-Date 2015",
    "$FOCA$TE$$": "Target-Date 2020",
    "$FOCA$TG$$": "Target-Date 2025",
    "$FOCA$TH$$": "Target-Date 2030",
    "$FOCA$TI$$": "Target-Date 2035",
    "$FOCA$TJ$$": "Target-Date 2040",
    "$FOCA$TK$$": "Target-Date 2045",
    "$FOCA$TL$$": "Target-Date 2055",
    "INCA000028": "Sector - FMCG",
    "INCA000029": "Sector - Energy",
    "INCA000030": "Sector - Financial Services",
    "INCA000031": "Equity - Other",
    "INCA000032": "Sector - Precious Metals",
    "INCA000033": "ELSS (Tax Savings)",
    "INCA000034": "Medium to Long Duration",
    "INCA000037": "Global - Other",
    "INCA000038": "Arbitrage Fund",
    "INCA000042": "Long Duration",
    "MXCA000038": "Other",
    "MXCA000039": "Asia Equity",
    "NZCA000044": "Equity Region Asia Pacific",
    "NZCA000045": "Equity Region Australasia",
    "NZCA000046": "Equity Region Australia",
    "NZCA000047": "Equity Region Emerging Markets",
    "NZCA000048": "Equity Region Europe",
    "NZCA000049": "Equity Region North America",
    "NZCA000050": "Equity Region NZ",
    "NZCA000051": "Equity Region World",
    "NZCA000052": "Equity Sector Global - Real Estate",
    "NZCA000053": "Equity Sector NZ - Real Estate",
    "NZCA000054": "Miscellaneous",
    "NZCA000055": "Mortgages",
    "NZCA000056": "Multisector - Aggressive",
    "NZCA000057": "Multisector - Balanced",
    "NZCA000058": "Multisector - Conservative",
    "NZCA000059": "Multisector - Growth",
    "NZCA000060": "Multisector - Moderate",
    "NZCA000061": "NZ Bonds",
    "NZCA000062": "Cash",
    "NZCA000063": "Global Bond",
    "NZCA000064": "Unlisted and Direct Property - Global",
    "NZCA000065": "Unlisted and Direct Property - NZ",
    "THCA000001": "Equity Small/Mid-Cap",
    "THCA000002": "Equity Large-Cap",
    "THCA000003": "Mid/Long Term Bond",
    "THCA000004": "Short Term Bond",
    "THCA000005": "Money Market",
    "THCA000006": "Capital Protected",
    "THCA000007": "Aggressive Allocation",
    "THCA000008": "Moderate Allocation",
    "THCA000009": "Global Equity",
    "THCA000010": "Emerging Market Equity",
    "THCA000011": "Asia Pacific ex-Japan Equity",
    "THCA000012": "Emerging Market Bond",
    "THCA000013": "Global Bond",
    "THCA000014": "Global Allocation",
    "THCA000015": "Foreign Investment Bond Fix Term",
    "THCA000016": "Capital Protection Fix Term",
    "THCA000018": "Bond Fix Term",
    "THCA000019": "Foreign Investment Equity Fix Term",
    "THCA000022": "Foreign Investment Miscellaneous",
    "EUCA000715": "South Africa & Namibia Equity",
    "EUCA000716": "Property - Indirect South Africa & Namibia",
    "EUCA000717": "ZAR/NAD Cautious Allocation",
    "EUCA000718": "ZAR/NAD Moderate Allocation",
    "EUCA000719": "ZAR/NAD Aggressive Allocation",
    "EUCA000720": "ZAR/NAD Flexible Allocation",
    "EUCA000721": "ZAR/NAD Bond - Ultra Short Term",
    "EUCA000722": "ZAR/NAD Bond - Short Term",
    "EUCA000723": "ZAR/NAD Diversified Bond",
    "EUCA000725": "ZAR/NAD Money Market",
    "MXCA000042": "Lifecycle",
    "MXCA000045": "Money Market USD",
    "MXCA000046": "Money Market EUR",
    "MXCA000047": "Capital Protected Funds",
    "MXCA000049": "Flexible Debt",
    "THCA000023": "Roll Over Bond",
    "CLCA000001": "Chile Equity",
    "CLCA000002": "Latin America Equity",
    "CLCA000003": "US Equity",
    "CLCA000004": "Europe Equity",
    "CLCA000005": "Global Equity",
    "CLCA000006": "Asia Equity",
    "CLCA000008": "Global Emerging Markets Equity",
    "CLCA000009": "Brazil Equity",
    "CLCA000010": "CLP Short Term Bond",
    "CLCA000011": "CLP Medium Term Bond",
    "CLCA000012": "CLP Long Term Bond",
    "CLCA000013": "Latin America Bond",
    "CLCA000015": "Global Emerging Markets Bond",
    "CLCA000023": "CLP Money Market",
    "CLCA000024": "USD Money Market",
    "CLCA000026": "Guaranteed Equity",
    "CLCA000027": "Guaranteed Fixed Income",
    "CLCA000028": "Alternative Strategies",
    "EUCA000726": "Israel Large/Mid-Cap Equity",
    "EUCA000727": "Israel Small-Cap Equity",
    "EUCA000728": "ILS Aggressive Allocation",
    "EUCA000729": "ILS Cautious Allocation",
    "EUCA000730": "ILS Diversified Bond",
    "EUCA000731": "Global Bond - ILS",
    "EUCA000732": "ILS Government Bond",
    "EUCA000733": "ILS Government Inflation-Linked Bond",
    "EUCA000734": "ILS Corporate & Convertible Bond",
    "EUCA000735": "ILS High Yield Bond",
    "EUCA000736": "ILS Inflation-Linked Bond",
    "EUCA000737": "ILS Money Market",
    "PGSZB4TTTT": "Aggressive Allocation Fund",
    "PGSZB5TTTT": "Aggressive Bond Fund",
    "AUCA000054": "Equity World - Currency Hedged",
    "CLCA000030": "Other",
    "CLCA000020": "Cautious Allocation",
    "CLCA000021": "Moderate Allocation",
    "CLCA000022": "Aggressive Allocation",
    "CHCA000002": "QDII Asia-Pacific ex-Japan Equity",
    "CHCA000005": "QDII Emerging Markets Equity",
    "CHCA000006": "QDII Global Equity",
    "CHCA000011": "QDII Sector Equity",
    "CHCA000014": "QDII US Equity",
    "$FOCA$5A$$": "Static Allocation--70% to 85% Equity",
    "$FOCA$5B$$": "Static Large Blend",
    "$FOCA$5C$$": "Static Allocation--30% to 50% Equity",
    "$FOCA$5E$$": "Static Mid-Cap Equity",
    "$FOCA$5G$$": "Static Large Growth",
    "$FOCA$5I$$": "Static Intermediate Bond",
    "$FOCA$5M$$": "Static Money Market",
    "$FOCA$5N$$": "Static Non US Equity",
    "$FOCA$5O$$": "Static Allocation--50% to 70% Equity",
    "$FOCA$5S$$": "Static Small-Cap Equity",
    "$FOCA$5T$$": "Static Short-Term Bond",
    "$FOCA$5U$$": "Static US Government",
    "$FOCA$5V$$": "Static Large Value",
    "$FOCA$AL$$": "Allocation--70% to 85% Equity",
    "$FOCA$CH$$": "China Region",
    "CACA000152": "Miscellaneous - Income and Real Property",
    "CACA000153": "Sector Equity",
    "CACA000154": "Geographic Equity",
    "CACA000155": "Commodity",
    "CACA000156": "Passive Inverse/Leveraged",
    "CACA000157": "Miscellaneous - Undisclosed Holdings",
    "KRCA000001": "Korea Large-Cap Equity",
    "KRCA000002": "Korea Small/Mid-Cap Equity",
    "KRCA000003": "Africa & Middle East Equity",
    "KRCA000004": "ASEAN Equity",
    "KRCA000005": "Asia-Pacific ex-Japan Equity",
    "KRCA000006": "Asia-Pacific with Japan Equity",
    "KRCA000007": "BRIC Equity",
    "KRCA000008": "Emerging Europe Equity",
    "KRCA000009": "Emerging Markets Equity",
    "KRCA000010": "Europe Equity",
    "KRCA000011": "Global Equity",
    "KRCA000012": "Latin America Equity",
    "KRCA000013": "Other Equity",
    "KRCA000014": "Brazil Equity",
    "KRCA000015": "China Equity",
    "KRCA000016": "India Equity",
    "KRCA000017": "Japan Equity",
    "KRCA000018": "Russia Equity",
    "KRCA000019": "US Equity",
    "KRCA000020": "Sector Equity Alternative Energy",
    "KRCA000021": "Sector Equity Consumer Goods and Services",
    "KRCA000022": "Sector Equity Ecology",
    "KRCA000023": "Sector Equity Financial Services",
    "KRCA000024": "Sector Equity Infrastructure",
    "KRCA000025": "Sector Equity Natural Resources",
    "KRCA000026": "Sector Equity Real Estate Indirect",
    "KRCA000027": "Sector Equity Real Estate Indirect - Asia",
    "KRCA000028": "Sector Equity Technology",
    "KRCA000029": "Sector Equity Other",
    "KRCA000030": "Korea Aggressive Allocation",
    "KRCA000031": "Korea Cautious Allocation",
    "KRCA000032": "Global Aggressive Allocation",
    "KRCA000033": "Global Cautious Allocation",
    "KRCA000034": "Other Aggressive Allocation",
    "KRCA000035": "Other Cautious Allocation",
    "KRCA000036": "Korea Bond",
    "KRCA000037": "Korea Corporate Bond",
    "KRCA000038": "Money Market",
    "KRCA000039": "Other Bond",
    "KRCA000040": "Derivative Commodities",
    "KRCA000041": "Other",
    "CHCA000009": "QDII Greater China Equity",
    "CHCA000016": "QDII Global Allocation",
    "EUCA000738": "CHF Moderate Allocation",
    "EUCA000739": "EUR Flexible Allocation - Global",
    "EUCA000740": "GBP Flexible Allocation",
    "EUCA000741": "Global Emerging Markets Allocation",
    "EUCA000742": "IDR Allocation",
    "EUCA000743": "Other Allocation",
    "EUCA000744": "PLN Allocation",
    "EUCA000745": "SEK Flexible Allocation",
    "EUCA000746": "USD Flexible Allocation",
    "EUCA000747": "CHF Bond - Short Term",
    "EUCA000748": "Convertible Bond - Europe",
    "EUCA000749": "Convertible Bond - Global",
    "EUCA000750": "Convertible Bond - Global, EUR Hedged",
    "EUCA000751": "Convertible Bond - Other",
    "EUCA000754": "EUR Flexible Bond",
    "EUCA000756": "GBP Diversified Bond - Short Term",
    "EUCA000757": "GBP Flexible Bond",
    "EUCA000758": "GBP Inflation-Linked Bond",
    "EUCA000759": "Global Bond",
    "EUCA000760": "Global Bond - CHF Hedged",
    "EUCA000761": "Global Bond - GBP Hedged",
    "EUCA000763": "Global Bond - USD Hedged",
    "EUCA000764": "Global Emerging Markets Bond - EUR Biased",
    "EUCA000765": "Global Emerging Markets Bond - Local Currency",
    "EUCA000766": "Global High Yield Bond",
    "EUCA000767": "USD Inflation-Linked Bond",
    "EUCA000768": "HKD Bond",
    "EUCA000769": "IDR Bond",
    "EUCA000771": "Other Bond",
    "EUCA000772": "PLN Bond",
    "EUCA000773": "SEK Inflation-Linked Bond",
    "EUCA000774": "SGD Bond",
    "EUCA000775": "USD Flexible Bond",
    "EUCA000779": "Asia ex-Japan Equity",
    "EUCA000780": "Indonesia Equity",
    "EUCA000781": "Property - Indirect North America",
    "EUCA000782": "South Africa & Namibia Small-Cap Equity",
    "EUCA000783": "Thailand Equity",
    "EUCA000784": "Commodities - Broad Agriculture",
    "EUCA000785": "Commodities - Broad Basket",
    "EUCA000786": "Commodities - Energy",
    "EUCA000787": "Commodities - Grains",
    "EUCA000788": "Commodities - Industrial & Broad Metals",
    "EUCA000789": "Commodities - Livestock",
    "EUCA000790": "Commodities - Other",
    "EUCA000791": "Commodities - Precious Metals",
    "EUCA000792": "Commodities - Softs",
    "EUCA000793": "Property - Direct Europe",
    "EUCA000794": "Property - Direct Global",
    "EUCA000795": "Property - Direct UK",
    "HSTG000001": "U.S. Long/Short Equity",
    "HSTG000002": "U.S. Small Cap Long/Short Equity",
    "HSTG000003": "Asia/Pacific Long/Short Equity",
    "HSTG000004": "Europe Long/Short Equity",
    "HSTG000005": "Emerging Markets Long/Short Equity",
    "HSTG000006": "Global Long/Short Equity",
    "HSTG000007": "Bear Market Equity",
    "HSTG000008": "Long/Short Debt",
    "HSTG000009": "Convertible Arbitrage",
    "HSTG000010": "Equity Market Neutral",
    "HSTG000011": "Debt Arbitrage",
    "HSTG000012": "Systematic Futures",
    "HSTG000013": "Global Macro",
    "HSTG000014": "Distressed Securities",
    "HSTG000015": "Event Driven",
    "HSTG000016": "Multistrategy",
    "HSTG000018": "Fund of Funds - Relative Value",
    "HSTG000019": "Fund of Funds - Equity",
    "HSTG000020": "Fund of Funds - Debt",
    "HSTG000021": "Fund of Funds - Multistrategy",
    "HSTG000022": "Fund of Funds - Event",
    "HSTG000023": "Fund of Funds - Macro/Systematic",
    "THCA000024": "Miscellaneous",
    "THCA000025": "Commodities Energy",
    "THCA000026": "Commodities Precious Metals",
    "CLCA000031": "Other Equity",
    "CLCA000032": "Sector Equity",
    "EUCA000796": "GBP Moderate Allocation",
    "$FOCA$13$$": "Managed Futures",
    "$FOCA$GY$$": "Multialternative",
    "$FOCA$IC$$": "Trading--Inverse Commodities",
    "$FOCA$IE$$": "Trading--Inverse Equity",
    "$FOCA$IS$$": "Trading--Miscellaneous",
    "$FOCA$LC$$": "Trading--Leveraged Commodities",
    "$FOCA$LE$$": "Trading--Leveraged Equity",
    "$FOCA$ND$$": "Trading--Inverse Debt",
    "$FOCA$VD$$": "Trading--Leveraged Debt",
    "$FOCA$VO$$": "Volatility",
    "EUCA000797": "Alt - Currency",
    "EUCA000798": "Alt - Relative Value Arbitrage",
    "EUCA000800": "Alt - Event Driven",
    "EUCA000804": "Alt - Global Macro",
    "EUCA000805": "Alt - Long/Short Credit",
    "EUCA000807": "Alt - Long/Short Equity - Europe",
    "EUCA000808": "Alt - Long/Short Equity - Global",
    "EUCA000809": "Alt - Long/Short Equity - UK",
    "EUCA000810": "Alt - Long/Short Equity - US",
    "EUCA000811": "Alt - Market Neutral - Equity",
    "EUCA000812": "Alt - Multistrategy",
    "EUCA000813": "Alt - Systematic Futures",
    "EUCA000814": "Alt - Volatility",
    "EUCA000815": "Trading - Leveraged/Inverse Commodities",
    "EUCA000816": "Trading - Leveraged/Inverse Equity",
    "EUCA000817": "Trading - Leveraged/Inverse Fixed Income",
    "EUCA000818": "Trading - Leveraged/Inverse Other",
    "EUCA000819": "EUR Corporate Bond - Short Term",
    "EUCA000821": "Convertible Bond - Global, CHF Hedged",
    "EUCA000822": "Convertible Bond - Global, GBP Hedged",
    "EUCA000823": "Convertible Bond - Global, USD Hedged",
    "EUCA000825": "Property - Indirect Other",
    "EUCA000826": "Property - Indirect Switzerland",
    "EUCA000827": "Sector Equity Agriculture",
    "EUCA000828": "Sector Equity Water",
    "EUCA000829": "Vietnam Equity",
    "EUCA000830": "EUR Money Market - Short Term",
    "EUCA000831": "GBP Money Market - Short Term",
    "EUCA000832": "USD Money Market - Short Term",
    "EUCA000833": "Money Market - Other",
    "CACA000158": "2025 Target Date Portfolio",
    "$FOCA$NT$$": "Nontraditional Bond",
    "CHCA000020": "Other",
    "CHCA000021": "QDII Global Bond",
    "CHCA000022": "QDII Commodities",
    "EUCA000834": "Other PP",
    "EUCA000835": "ILS Cautious Allocation, 10% Equity Cap",
    "EUCA000836": "Global Small-Cap Equity",
    "EUCA000837": "EUR Government Bond - Short Term",
    "EUCA000838": "ZAR/NAD Flexible Bond",
    "EUCA000840": "Islamic Global Equity",
    "KRCA000044": "Asia Pacific Cautious Allocation",
    "KRCA000045": "Lifecycle",
    "KRCA000046": "Leveraged Equity",
    "MXCA000050": "Government Debt - Medium Term",
    "MXCA000051": "MXN Long-Term Debt",
    "MXCA000052": "MXN Medium-Term Debt",
    "MXCA000053": "MXN Short-Term Debt",
    "MECA000001": "Global Allocation",
    "MECA000002": "Global Islamic Allocation",
    "MECA000003": "Other Allocation",
    "MECA000004": "Asia Equity",
    "MECA000005": "Emerging Markets Equity",
    "MECA000006": "Europe Equity",
    "MECA000007": "GCC Equity",
    "MECA000008": "GCC Islamic Equity",
    "MECA000009": "Global Equity",
    "MECA000010": "Global Islamic Equity",
    "MECA000011": "Kuwait Equity",
    "MECA000012": "Kuwait Islamic Equity",
    "MECA000013": "MENA Equity",
    "MECA000014": "Oman Equity",
    "MECA000015": "Other Equity",
    "MECA000016": "Qatar Equity",
    "MECA000017": "Saudi Equity",
    "MECA000018": "Saudi Islamic Equity",
    "MECA000019": "Sector Equity Other",
    "MECA000020": "Sector Equity Real Estate",
    "MECA000021": "UAE Equity",
    "MECA000022": "US Equity",
    "MECA000023": "Bond & Sukuk",
    "MECA000024": "Money Market",
    "MECA000025": "Other",
    "$FOCA$EI$$": "India Equity",
    "$FOCA$FQ$$": "Foreign Small/Mid Blend",
    "$FOCA$TN$$": "Target-Date 2050",
    "AUCA000055": "Bonds - Inflation-linked",
    "AUCA000056": "Equity Greater China",
    "AUCA000057": "Commodities & Precious Metals",
    "AUCA000058": "Equity Global Resources",
    "EUCA000845": "Global Frontier Markets Equity",
    "EUCA000846": "UK Equity Income",
    "EUCA000847": "Property - Indirect Eurozone",
    "EUCA000850": "Europe Mid-Cap Equity",
    "EUCA000851": "Eurozone Mid-Cap Equity",
    "EUCA000852": "UK Mid-Cap Equity",
    "EUCA000853": "US Mid-Cap Equity",
    "EUCA000854": "Global High Yield Bond - EUR Hedged",
    "EUCA000855": "Global High Yield Bond - GBP Hedged",
    "EUCA000856": "RMB Bond",
    "EUCA000857": "French PEA Eonia SWAP",
    "HSTG000024": "China Long/Short Equity",
    "HSTG000025": "Currency",
    "HSTG000026": "Diversified Arbitrage",
    "HSTG000027": "Merger Arbitrage",
    "HSTG000028": "Volatility",
    "HSTG000029": "Long-Only Debt",
    "HSTG000030": "Emerging Markets Long-Only Equity",
    "HSTG000031": "Long-Only Equity",
    "HSTG000032": "Long-Only Other",
    "AUCA000059": "Equity Australia Derivative Income",
    "EUCA000858": "Global Inflation-Linked Bond",
    "EUCA000859": "Global Inflation-Linked Bond - EUR Hedged",
    "EUCA000860": "Global Inflation-Linked Bond - GBP Hedged",
    "EUCA000861": "Global Inflation-Linked Bond - USD Hedged",
    "INCA000043": "Aggressive Allocation",
    "INCA000044": "Dynamic Asset Allocation",
    "INCA000045": "Flex-Cap Equity",
    "INCA000046": "Other Bond",
    "INCA000047": "Guaranteed Funds",
    "MXCA000054": "Government Debt - Short Term",
    "HKMP000001": "Aggressive Allocation",
    "HKMP000002": "Cautious Allocation",
    "HKMP000003": "Moderate Allocation",
    "HKMP000005": "Target Date",
    "HKMP000006": "Guaranteed Funds",
    "HKMP000008": "China & Greater China Equity",
    "HKMP000009": "Europe Equity",
    "HKMP000010": "Global Equity",
    "HKMP000011": "US Equity",
    "HKMP000012": "Other Equity",
    "HKMP000013": "Hong Kong Equity",
    "HKMP000014": "Japan Equity",
    "HKMP000015": "Global Bond",
    "HKMP000016": "Other Bond",
    "HKMP000017": "HKD Money Market",
    "HKMP000018": "Other Money Market",
    "CACA000160": "Preferred Share Fixed Income",
    "$FOCA$FX$$": "Single Currency",
    "$FOCA$MQ$$": "Miscellaneous Region",
    "BRCA000001": "Brazil Large-Cap Equity",
    "BRCA000002": "Brazil Mid & Small Cap Equity",
    "BRCA000003": "Brazil All Cap Equity",
    "BRCA000004": "Sector Equity",
    "BRCA000005": "Foreign Equity",
    "BRCA000006": "Single-Company Equity",
    "EUCA000862": "EUR Aggressive Allocation",
    "EUCA000863": "EUR Cautious Allocation",
    "EUCA000864": "EUR Flexible Allocation",
    "EUCA000865": "EUR Moderate Allocation",
    "EUCA000867": "Target Date 2011 - 2015",
    "EUCA000868": "Target Date 2016 - 2020",
    "EUCA000869": "Target Date 2021 - 2025",
    "EUCA000870": "Target Date 2026 - 2030",
    "EUCA000871": "Target Date 2031 - 2035",
    "EUCA000872": "Target Date 2036 - 2040",
    "EUCA000873": "Target Date 2041 - 2045",
    "EUCA000874": "Target Date 2046+",
    "EUCA000875": "Europe Equity Income",
    "EUCA000876": "Global Equity Income",
    "EUCA000877": "Asia High Yield Bond",
    "EUCA000878": "Global Emerging Markets Corporate Bond",
    "EUCA000879": "Global Emerging Markets Corporate Bond - EUR Biased",
    "EUCA000880": "Alt - Long/Short Equity - Other",
    "EUCA000881": "Alt - Other",
    "JPCA000058": "World Bond - JPY Hedged",
    "JPCA000059": "World ex-Japan Bond - JPY Hedged",
    "JPCA000060": "World Other Bond",
    "JPCA000061": "World High Yield Bond Global - JPY Hedged",
    "JPCA000062": "Emerging Bond - JPY Hedged",
    "JPCA000063": "Emerging Other Bond",
    "JPCA000064": "Emerging High Yield Bond",
    "JPCA000065": "Emerging High Yield Bond - JPY Hedged",
    "JPCA000066": "World ST Bond/Money - JPY Hedged",
    "$FOCA$RR$$": "Preferred Stock",
    "$FOCA$TV$$": "Tactical Allocation",
    "$FOCA$TW$$": "Corporate Bond",
    "AUCA000060": "Bonds - Emerging Market Debt",
    "CHCA000023": "Pure Bond",
    "CHCA000024": "Convertible Bond",
    "EUCA000882": "Global Bond - NOK Hedged",
    "KRCA000048": "Global Bond",
    "KRCA000049": "Global Emerging Markets Bond",
    "KRCA000050": "Global High Yield Bond",
    "BRCA000007": "BRL Money Market",
    "BRCA000008": "BRL Diversified Bond - Government Biased",
    "BRCA000009": "BRL Government Bond",
    "BRCA000010": "BRL Corporate Bond",
    "BRCA000011": "BRL Diversified Bond - Corporate Biased",
    "BRCA000012": "Foreign Bond",
    "BRCA000013": "Other",
    "BRCA000014": "Brazilian Bond - USD Hedged",
    "MYCA000001": "Aggressive Allocation",
    "MYCA000002": "Moderate Allocation",
    "MYCA000003": "Cautious Allocation",
    "MYCA000004": "Other Equity",
    "MYCA000005": "Other Bond",
    "CACA000161": "Energy Equity",
    "$FOCA$LP$$": "Energy Limited Partnership",
    "BRCA000016": "Alt - Debt & Currencies",
    "BRCA000017": "Alt - Equity Long biased",
    "BRCA000018": "Alt - Equity Long-short",
    "BRCA000021": "Alt - Multistrategy",
    "BRCA000022": "Alt - Other",
    "EUCA000888": "Fixed Term Bond",
    "EUCA000889": "Global Corporate Bond",
    "EUCA000890": "Global Corporate Bond - CHF Hedged",
    "EUCA000891": "Global Corporate Bond - EUR Hedged",
    "EUCA000892": "Global Corporate Bond - GBP Hedged",
    "EUCA000893": "Global Corporate Bond - USD Hedged",
    "EUCA000894": "Global High Yield Bond - CHF Hedged",
    "HKMP000019": "Asia ex-Japan Equity",
    "HKMP000020": "Asia-Pacific ex-Japan Equity",
    "HKMP000021": "HKD Bond",
    "MXCA000055": "MXN Inflation-Linked Debt",
    "CHCA000025": "Market Neutral",
    "CHCA000026": "Commodities",
    "CHCA000028": "QDII Other",
    "EUCA000895": "TWD Moderate Allocation",
    "EUCA000896": "China Equity - A Shares",
    "EUCA000897": "Asia Bond - Local Currency",
    "INCA000048": "Multi-Cap",
    "INCA000049": "Fixed Maturity Intermediate-Term Bond",
    "THCA000027": "US Equity",
    "THCA000028": "Japan Equity",
    "THCA000029": "China Equity",
    "THCA000030": "Europe Equity",
    "THCA000031": "Equity Fix Term",
    "THCA000032": "Conservative Allocation",
    "THCA000033": "High Yield Bond Fix Term",
    "THCA000034": "Global High Yield Bond Fix Term",
    "THCA000035": "Property Indirect",
    "AUCA000061": "Multisector Life Stages - 1940s and earlier",
    "AUCA000062": "Multisector Life Stages - 1950s",
    "AUCA000063": "Multisector Life Stages - 1960s",
    "AUCA000064": "Multisector Life Stages - 1970s",
    "AUCA000065": "Multisector Life Stages - 1980s",
    "AUCA000066": "Multisector Life Stages - 1990s and later",
    "AUCA000067": "Alternative Strategies - Diversified",
    "AUCA000068": "Alternative Strategies - Managed Futures",
    "EUCA000898": "SEK Moderate Allocation",
    "EUCA000899": "Global Flexible Bond",
    "EUCA000900": "Global Flexible Bond - CHF Hedged",
    "EUCA000901": "Global Flexible Bond - EUR Hedged",
    "EUCA000902": "Global Flexible Bond - USD Hedged",
    "EUCA000903": "Global Flexible Bond - GBP Hedged",
    "EUCA000904": "RMB High Yield Bond",
    "EUCA000905": "SEK Corporate Bond",
    "KRCA000051": "ELF/DLF",
    "CACA000162": "Floating Rate Loans",
    "AUCA000069": "Miscellaneous NZD",
    "BRCA000024": "Restricted and Exclusive",
    "EUCA000906": "RMB Bond - Onshore",
    "EUCA000907": "Asia ex-Japan Small/Mid-Cap Equity",
    "KRCA000052": "Alt - Long/Short Equity - Korea",
    "KRCA000053": "Alt - Long/Short Equity - Other",
    "KRCA000054": "Alt - Market Neutral - Equity",
    "KRCA000055": "Alt - Other",
    "MYCA000006": "Blended - Aggressive",
    "MYCA000007": "Blended - Balanced",
    "MYCA000008": "Blended - Balanced (Sharia)",
    "MYCA000009": "Blended - Conservative",
    "MYCA000010": "Blended - Flexible",
    "MYCA000011": "Blended - Other",
    "MYCA000012": "Equity - ASEAN",
    "MYCA000013": "Equity - Asia Pacific",
    "MYCA000014": "Equity - Asia Pacific ex-Japan",
    "MYCA000015": "Equity - Asia Pacific ex-Japan (Sharia)",
    "MYCA000016": "Equity - Country Focus",
    "MYCA000017": "Equity - Emerging Markets",
    "MYCA000018": "Equity - Global",
    "MYCA000019": "Equity - Greater China",
    "MYCA000020": "Equity - Malaysia Income",
    "MYCA000021": "Equity - Malaysia Large-cap",
    "MYCA000022": "Equity - Malaysia Large-cap (Sharia)",
    "MYCA000023": "Equity - Malaysia Mid/Small-cap",
    "MYCA000024": "Equity - Malaysia Mid/Small-cap (Sharia)",
    "MYCA000025": "Equity - Other",
    "MYCA000026": "Equity - Sector Focus",
    "MYCA000027": "Property - Indirect Asia",
    "MYCA000028": "Property - Indirect Non-Asia",
    "MYCA000029": "Bonds - Asia",
    "MYCA000030": "Bonds - Emerging Markets",
    "MYCA000031": "Bonds - Global",
    "MYCA000032": "Bonds - Global Hedged",
    "MYCA000033": "Bonds - Malaysia",
    "MYCA000034": "Bonds - Malaysia (Sharia)",
    "MYCA000035": "Bonds - Other",
    "MYCA000036": "Other - Miscellaneous",
    "MYCA000037": "Other - Protected or Guaranteed",
    "MYCA000038": "Other - Target Date",
    "MYCA000039": "Money Market - Malaysia",
    "MYCA000040": "Money Market - Malaysia (Sharia)",
    "THCA000036": "Global Health Care",
    "$FOCA$XL$$": "Static Allocation--15% to 30% Equity",
    "$FOCA$XM$$": "Allocation--85%+ Equity",
    "$FOCA$XN$$": "Static Allocation--85%+ Equity",
    "$FOCA$XO$$": "Infrastructure",
    "$FOCA$XP$$": "Emerging-Markets Local-Currency Bond",
    "$FOCA$XQ$$": "Target-Date 2060+",
    "$FOCA$XR$$": "Options-based",
    "$FOCA$XS$$": "Long-Short Credit",
    "$FOCA$XT$$": "Prime Money Market",
    "$FOCA$XY$$": "Allocation--15% to 30% Equity",
    "CHCA000029": "QDII Asia Allocation",
    "CHCA000030": "QDII Emerging Markets Allocation",
    "CHCA000031": "QDII Greater China Allocation",
    "CHCA000032": "Flexible Allocation Fund",
    "EUCA000908": "NOK Aggressive Allocation",
    "EUCA000909": "NOK Cautious Allocation",
    "EUCA000910": "Global Emerging Markets Small/Mid-Cap Equity",
    "EUCA000911": "DKK Domestic Bond",
    "EUCA000912": "DKK Domestic Bond - Short Term",
    "EUCA000913": "NOK High Yield Bond",
    "EUCA000914": "Property - Direct Switzerland",
    "INCA000050": "Credit Risk",
    "JPCA000067": "Moderately Aggressive Allocation",
    "JPCA000068": "Moderately Conservative Allocation",
    "JPCA000069": "Other Allocation",
    "JPCA000070": "Risk Control Allocation",
    "JPCA000071": "Target Date 2031-2040",
    "JPCA000072": "Target Date 2041 and later",
    "JPCA000073": "World Convertible Bond - JPY Hedged",
    "JPCA000074": "Australia & New Zealand Equity",
    "JPCA000075": "Brazil Equity",
    "JPCA000076": "Emerging Asia Equity",
    "JPCA000077": "Europe Equity - JPY Hedged",
    "JPCA000078": "Japan Other Equity",
    "JPCA000079": "Japan Other REIT",
    "JPCA000080": "Japan Small/Mid-Cap Blend Equity",
    "JPCA000081": "Japan Small/Mid-Cap Growth Equity",
    "JPCA000082": "Japan Small/Mid-Cap Value Equity",
    "JPCA000083": "Japan Specialty Equity",
    "JPCA000084": "North America Equity - JPY Hedged",
    "JPCA000085": "US REIT",
    "JPCA000086": "US REIT - JPY Hedged",
    "JPCA000087": "World Equity - JPY Hedged",
    "JPCA000088": "World ex-Japan Equity - JPY Hedged",
    "JPCA000089": "World Other Equity",
    "JPCA000090": "World REIT - JPY Hedged",
    "JPCA000091": "World REIT - Specific Region / Country",
    "JPCA000092": "World Other REIT",
    "JPCA000093": "Australia & New Zealand - JPY Hedged",
    "JPCA000094": "Emerging Asia Bond",
    "JPCA000095": "Emerging Europe/Other Bond",
    "JPCA000096": "Emerging Latin America Bond",
    "JPCA000097": "Europe Bond - JPY Hedged",
    "JPCA000098": "Japan Other Bond",
    "JPCA000099": "North America Bond - JPY Hedged",
    "JPCA000100": "World Bond Inflation / Floating",
    "JPCA000101": "World High Yield Bond Europe",
    "JPCA000102": "World High Yield Bond Europe - JPY Hedged",
    "JPCA000103": "World High Yield Bond US",
    "JPCA000104": "World High Yield Bond US - JPY Hedged",
    "JPCA000105": "General Miscellaneous",
    "KRCA000056": "Sector Equity Healthcare",
    "MXCA000056": "Government Debt - Long Term",
    "MXCA000057": "Europe Equity",
    "CACA000163": "Short-term Target Date Portfolio",
    "CACA000164": "2030 Target Date Portfolio",
    "CACA000165": "2035 Target Date Portfolio",
    "CACA000166": "2035+ Target Date Portfolio",
    "CACA000167": "Global Infrastructure Equity",
    "EUCA000915": "Japan Flex-Cap Equity",
    "INCA000051": "Equity - Infrastructure",
    "KRCA000057": "Vietnam Equity",
    "THCA000037": "Property - Indirect Global",
    "$FOCA$SW$$": "World Small/Mid Stock",
    "CHCA000033": "Shanghai-Hong Kong-Shenzhen Equity",
    "CHCA000034": "Sector Equity Health",
    "CHCA000035": "Sector Equity Technology and Communications",
    "CHCA000036": "Shanghai-Hong Kong-Shenzhen Allocation",
    "EUCA000916": "GBP Moderately Adventurous Allocation",
    "EUCA000917": "GBP Moderately Cautious Allocation",
    "EUCA000918": "Asia-Pacific ex-Japan Equity Income",
    "INCA000052": "Multi Asset Allocation",
    "INCA000053": "Dynamic Bond",
    "KRCA000058": "Target Achievement",
    "MXCA000058": "Siefore Basica 0",
    "MXCA000059": "Siefore Basica 1",
    "MXCA000060": "Siefore Basica 2",
    "MXCA000061": "Siefore Basica 3",
    "MXCA000062": "Siefore Basica 4",
    "MXCA000063": "Siefore Basica Adicional",
    "AUCA000070": "Multisector Flexible",
    "JPCA000106": "World Bank Loan",
    "JPCA000107": "World Bank Loan - JPY Hedged",
    "MXCA000064": "Foreign Currency Debt",
    "NZCA000066": "Equity Region World - Hedged",
    "CACA000168": "Canadian Corporate Fixed Income",
    "CACA000169": "Global Corporate Fixed Income",
    "CACA000170": "Emerging Markets Fixed Income",
    "$FOCA$N4$$": "Money Market-Non-40 Act",
    "BRCA000025": "Allocation, up to 20% Equity",
    "BRCA000026": "Allocation, 20% to 40% Equity",
    "BRCA000027": "Allocation, 40% to 60% Equity",
    "BRCA000028": "Equity-Biased Allocation",
    "EUCA000919": "Greater China Allocation",
    "EUCA000920": "Nordic Small/Mid-Cap Equity",
    "EUCA000921": "Pacific ex-Japan Equity",
    "KRCA000059": "China Cautious Allocation",
    "KRCA000060": "China Aggressive Allocation",
    "KRCA000061": "Korea Equity Income",
    "THCA000038": "ASEAN Equity",
    "THCA000039": "India Equity",
    "INCA000054": "Small-Cap",
    "INCA000055": "Large & Mid-Cap",
    "INCA000056": "Value",
    "INCA000057": "Contra",
    "INCA000058": "Dividend Yield",
    "INCA000059": "Focused Fund",
    "INCA000060": "Index Funds",
    "INCA000061": "Low Duration",
    "INCA000062": "Money Market",
    "INCA000063": "Medium Duration",
    "INCA000064": "Corporate Bond",
    "INCA000065": "Banking & PSU",
    "INCA000066": "Floating Rate",
    "INCA000067": "Overnight",
    "INCA000068": "Equity Savings",
    "INCA000069": "Retirement",
    "INCA000070": "Children",
    "INCA000071": "Fund of Funds",
    "CHCA000037": "Hong Kong Equity",
    "JPCA000108": "Japan Cash Balanced Equity",
    "THCA000040": "Global Technology",
    "THCA000041": "Global Infrastructure",
    "THCA000042": "Global High Yield Bond",
    "$FOCA$A1$$": "Age 0-4",
    "$FOCA$A2$$": "Age 5-6",
    "$FOCA$A3$$": "Age 7-8",
    "$FOCA$A4$$": "Age 9-10",
    "$FOCA$A5$$": "Age 11-12",
    "$FOCA$A6$$": "Age 13-14",
    "$FOCA$A7$$": "Age 15-16",
    "$FOCA$A8$$": "Age 17-18",
    "$FOCA$A9$$": "Age 19+",
    "$FOCA$MM$$": "Muni Target Maturity",
    "$FOCA$PI$$": "Intermediate Core-Plus Bond",
    "$FOCA$T0$$": "Target-Enrollment 2033",
    "$FOCA$T1$$": "Target-Enrollment 2039+",
    "$FOCA$T2$$": "Target-Enrollment 2036",
    "$FOCA$T3$$": "Target-Enrollment 2030",
    "$FOCA$T4$$": "Target-Enrollment 2027",
    "$FOCA$T5$$": "Target-Enrollment 2024",
    "$FOCA$T6$$": "Target-Enrollment 2021",
    "$FOCA$T7$$": "Target-Enrollment 2018",
    "$FOCA$T8$$": "Target-Enrollment 2015",
    "$FOCA$T9$$": "Target-Enrollment College",
    "$FOCA$TT$$": "Target Maturity",
    "$FOCA$WH$$": "World Bond-USD Hedged",
    "CACA000171": "Alternative Equity Focused",
    "CACA000172": "Alternative Credit Focused",
    "CACA000173": "Alternative Multi â€“ Strategy",
    "CACA000174": "Alternative Market Neutral",
    "CACA000175": "Alternative Other",
    "EUCA000922": "EUR Subordinated Bond",
    "HKMP000022": "DIS - Core Accumulation Fund",
    "HKMP000023": "DIS - Age 65 Plus Fund",
    "INCA000072": "Equity - Consumption",
    "INCA000073": "Group Equity",
    "INCA000074": "Group Bond",
    "INCA000075": "Group Allocation",
    "KRCA000062": "Target-Date 2015",
    "KRCA000063": "Korea Flexible Allocation",
    "KRCA000064": "Target-Date 2020",
    "KRCA000065": "Target-Date 2025",
    "KRCA000066": "Target-Date 2030",
    "KRCA000067": "Target-Date 2035",
    "KRCA000068": "Target-Date 2040",
    "KRCA000069": "Target-Date 2045",
    "KRCA000070": "Target-Date 2050",
    "KRCA000071": "Target-Date Retirement",
    "THCA000043": "Country Focus Equity",
    "THCA000044": "TH Sector Focus Equity",
    "THCA000045": "Global Sector Focus Equity"
}
const freq = {
    "A$": "Annually",
    "a$": "Semi - Annually",
    "B$": "Bi - Monthly",
    "M$": "Monthly",
    "m$": "Semi - Monthly",
    "N$": "None",
    "Q$": "Quarterly",
    "W$": "Weekly",
    "D$": "Daily"
}

export function catslist(){
    var obj = cats
    var result = Object.keys(obj).map((key) => [Number(key), obj[key]]);
    return result
}

// function onlyUnique(value, index, self) {
//     return self.indexOf(value) === index;
// }

export function shortlist(){
    //return  Object.values(short);
    return [...new Set(Object.values(short))]
    //return  n.filter(onlyUnique);

}

export const short = {
    "1167 Capital LLP":"1167",
    "1OAK Capital Limited":"1OAK",
    "24 Capital Management Ltd":"24",
    "3i Investments PLC":"3i",
    "8AM Global LLP":"8AM",
    "A&L Goodbody (Ireland)":"A&L Goodbody",
    "Abacus Financial Services Ltd":"Abacus",
    "Aberdeen Asset Investments Limited":"Aberdeen",
    "Aberdeen Asset Management Funds Ltd (UK)":"Aberdeen",
    "Aberdeen Asset Managers Limited":"Aberdeen",
    "Aberdeen Asset Managers Ltd":"Aberdeen",
    "Aberdeen Asset Managers Ltd (London)":"Aberdeen",
    "Aberdeen Asset Mgmt":"Aberdeen",
    "ABERDEEN STANDARD CAPITAL INTERNATIONAL LTD.":"Aberdeen Standard",
    "Aberdeen Standard Fund Managers Limited":"Aberdeen Standard",
    "Aberdeen Standard Investments":"Aberdeen Standard",
    "Aberdeen Standard Investments (Asia) Limited":"Aberdeen Standard",
    "Aberdeen Standard Investments (Hong Kong) Limited":"Aberdeen Standard",
    "Aberdeen Standard Investments Australia Limited":"Aberdeen Standard",
    "Aberdeen Standard Investments Inc.":"Aberdeen Standard",
    "Aberdeen Standard Investments Limited":"Aberdeen Standard",
    "Aberforth Partners LLP":"Aberforth",
    "Abraxas Capital Management Limited":"Abraxas",
    "Absolute Return Partners LLP":"Absolute Return",
    "Acadian Asset Management":"Acadian",
    "Acadian Asset Management LLC":"Acadian",
    "Acheron Capital Ltd":"Acheron",
    "Acorn Asset Management Ltd":"Acorn",
    "Activus Wealth Ltd":"Activus",
    "ADAM & CO INVESTMENT MANAGEMENT":"ADAM & CO",
    "Adams PLC":"Adams",
    "Adelphi Capital LLP":"Adelphi",
    "ADG Capital Management LLP":"ADG",
    "Aditya Birla Sun Life Asset Management Company Pte Ltd":"Aditya Birla Sun Life",
    "Advent Capital Management, LLC":"Advent",
    "Aegon Asset Management UK PLC":"Aegon",
    "Aegon Investment Management BV":"Aegon",
    "AEGON Investments Limited":"AEGON",
    "AEW UK Investment Management LLP":"AEW",
    "Affirmative Investment Management Partners Limited":"Affirmative",
    "AFH Independent Financial Services Ltd":"AFH Independent",
    "Africa Opportunity Partners Limited":"Africa Opportunity",
    "AGF International Advisors Co Ltd":"AGF",
    "AHL Partners LLP":"AHL",
    "AIVA":"AIVA",
    "AJ Bell Asset Management Limited":"AJ Bell",
    "Albion Capital Group LLP":"Albion",
    "Alcentra Limited":"Alcentra",
    "Alcentra NY, LLC":"Alcentra",
    "Alder Investment Management Limited":"Alder",
    "Alfred Berg Kapitalforvaltning AS":"Alfred Berg",
    "Algebris (UK) Limited":"Algebris",
    "Alger Management Ltd":"Alger",
    "Alken Asset Management LLP":"Alken",
    "Alken Asset Management Ltd":"Alken",
    "Alkeon Capital Management, LLC":"Alkeon",
    "Allenby Capital Ltd":"Allenby",
    "AllianceBernstein L.P.":"AllianceBernstein",
    "AllianceBernstein Ltd":"AllianceBernstein",
    "Allianz Global Investors (UK) Ltd":"Allianz",
    "Allianz Global Investors Asia Pacific Limited":"Allianz",
    "Allianz Global Investors GmbH":"Allianz",
    "Allianz Global Investors GmbH – Frankfurt":"Allianz",
    "Allianz Global Investors GmbH, France Branch - Paris":"Allianz",
    "Allianz Global Investors GmbH, UK Branch – London":"Allianz",
    "Allianz Global Investors Japan Co Ltd":"Allianz",
    "Allianz Global Investors Singapore Limited":"Allianz",
    "Allianz Global Investors U.S. LLC":"Allianz",
    "Allianz Global Investors U.S. LLC – San Diego":"Allianz",
    "Allianz Global Investors U.S. LLC - San Francisco":"Allianz",
    "AllianzGI UK Branch":"Allianz",
    "Alma Capital Investment Management":"Alma",
    "Alpha Japan Asset Advisors Limited":"Alpha",
    "Alpha Real Capital LLP":"Alpha Real",
    "Alpine Associates Management Inc.":"Alpine",
    "Alquity Investment Management Limited":"Alquity",
    "Alta Capital Management LLC":"Alta",
    "Alter Domus Management Company SA":"Alter Domus",
    "Alvarium Home REIT Advisors Limited":"Alvarium Home REIT",
    "Alvarium Investment Managers (UK) LLP":"Alvarium",
    "AM Fund Product Management":"AM Product",
    "Amati Global Investors Ltd":"Amati",
    "Amber Capital UK Llp":"Amber",
    "Amber Fund Management Limited":"Amber",
    "Amedeo Limited":"Amedeo",
    "American Century Investment Management, Inc":"American Century",
    "AMP Capital Investors Limited":"AMP",
    "AMR Financial Management Limited":"AMR Financial",
    "Amundi (UK) Limited":"Amundi",
    "Amundi Asset Management":"Amundi",
    "Amundi Asset Management US, Inc.":"Amundi",
    "Amundi Asset Management, London Branch":"Amundi",
    "Amundi Hong Kong Ltd":"Amundi",
    "Amundi Japan Ltd":"Amundi",
    "Amundi Singapore Ltd":"Amundi",
    "Anavon Capital LLP":"Anavon",
    "Andbank Asset Management Luxembourg":"Andbank",
    "Anderson Strathern Asset Management":"Anderson Strathern",
    "Andurand Capital Management Ltd":"Andurand",
    "ANF Luxembourg S.A.":"ANF",
    "Antipodes Partners Limited":"Antipodes",
    "Apax Guernsey Managers Ltd":"Apax",
    "Aperture Investors UK Ltd":"Aperture",
    "Aperture Investors, LLC":"Aperture",
    "Apollo Multi Asset Management LLP":"Apollo",
    "APS Asset Management Pte Limited":"APS",
    "AQR Capital Management LLC":"AQR",
    "AQR Capital Management, LLC":"AQR",
    "Aquila Capital Investmentgesellschaft mbH":"Aquila",
    "Arabesque Asset Management Ltd":"Arabesque",
    "Arbrook Investors Ltd":"Arbrook",
    "Arctic Asset Management AS":"Arctic AS",
    "Arcus Investment Limited":"Arcus",
    "Ardevora Asset Management LLP":"Ardevora",
    "Argonaut Capital Partners LLP":"Argonaut",
    "Arisaig Partners (Asia) Pte Ltd":"Arisaig",
    "Aristotle Capital Management LLC":"Aristotle",
    "Armstrong Investment Managers LLP":"Armstrong",
    "Artemis Fund Managers Limited":"Artemis",
    "Artemis Investment Management LLP":"Artemis",
    "Artisan Partners Limited Partnership":"Artisan",
    "ARX Investimentos Ltda":"ARX",
    "AS SEB Varahaldus":"AS SEB Varahaldus",
    "Ascencia Investment Management Limited":"Ascencia",
    "Ashburton (Jersey) Limited":"Ashburton",
    "Ashmore Investment Management Limited":"Ashmore",
    "Asia Frontier Capital Ltd.":"Frontier",
    "Asia Frontier Investments Ltd, Hong Kong":"Frontier",
    "Assenagon Asset Management SA":"Assenagon",
    "Asset Intelligence Portfolio Management Limited":"Asset Intelligence",
    "Asset Management One Co., Ltd.":"Asset Management One",
    "Asset Management One International Ltd":"Asset Management One",
    "Asset Value Investors Limited":"Asset Value Investors",
    "Astute Investment Management Ltd":"Astute",
    "Athelney Trust PLC":"Athelney Trust",
    "Atlantic House Fund Management LLP":"Atlantic House",
    "Atlantis Investment Management (HK) Ltd":"Atlantis",
    "ATLAS Infrastructure Partners (UK) Ltd":"ATLAS Infrastructure",
    "Atrato Capital Limited":"Atrato",
    "Aubrey Capital Management Ltd":"Aubrey",
    "Augmentum Fintech PLC":"Augmentum Fintech",
    "Ausbil Investment Management Limited":"Ausbil",
    "Avellemy Limited":"Avellemy",
    "Aventicum Capital Management (UK) LLP":"Aventicum",
    "Aviva Investors Global Services Limited":"Aviva",
    "Aviva Investors UK Fund Services Limited":"Aviva",
    "AXA Framlington Investment Mgmt Ltd":"AXA",
    "AXA Investment Managers":"AXA",
    "AXA Investment Managers Asia Ltd.":"AXA",
    "AXA Investment Managers Chorus Limited":"AXA",
    "AXA Investment Managers HK Ltd":"AXA",
    "AXA Investment Managers Inc":"AXA",
    "AXA Investment Managers Paris":"AXA",
    "AXA Investment Managers UK Ltd":"AXA",
    "AXA Isle of Man Limited":"AXA",
    "Axiom Alternative Investments":"Axiom Alternative",
    "Axiom International Investors LLC":"Axiom",
    "BAF Capital AG":"BAF",
    "Baggette Asset Management Limited":"Baggette",
    "Baillie Gifford & Co":"Baillie Gifford",
    "Baillie Gifford & Co Limited.":"Baillie Gifford",
    "Baillie Gifford Investment Management (Europe) Limited":"Baillie Gifford",
    "Baker Steel Capital Managers (Cayman) Limited":"Baker Steel",
    "Baker Steel Capital Managers LLP":"Baker Steel",
    "BAMCO Inc":"BAMCO",
    "Bank J. Safra Sarasin":"Safra Sarasin",
    "Bank J. Safra Sarasin AG":"Safra Sarasin",
    "Bank J. Safra Sarasin Ltd.":"Safra Sarasin",
    "Bank Julius Bär & Co. AG":"Bank Julius Bär",
    "Bank Julius Bär & Co. Ltd., Singapore Branch":"Bank Julius Bär & Branch",
    "Bank Lombard Odier & Co AG":"Lombard Odier",
    "Bank SYZ Ltd":"Bank SYZ",
    "Bank Vontobel AG":"Vontobel",
    "Banor Capital Ltd":"Banor",
    "Banque Bonhôte & Cie SA":"Banque Bonhôte",
    "Banque Lombard Odier & Cie SA":"Lombard Odier",
    "Banque Pictet & Cie SA":"Pictet",
    "Barclays Asset Management Limited":"Barclays",
    "Barclays Bank PLC":"Barclays",
    "Barclays Investment Solutions Limited":"Barclays",
    "Barclays Wealth Mgmt Jersey Ltd":"Barclays",
    "Baring Asset Management Ltd":"Baring",
    "Baring Fund Managers Ltd":"Baring",
    "Barings LLC":"Barings",
    "Barratt & Cooke Limited":"Barratt & Cooke",
    "BBGI Management HoldCo":"BBGI HoldCo",
    "BBVA Asset Management SA SGIIC":"BBVA",
    "Beaufort Investment Management Limited":"Beaufort",
    "Bedrock Asset Management (UK) Ltd":"Bedrock",
    "Bellevue Asset Management AG":"Bellevue",
    "Belle-Vue Conseils":"BelleVue Conseils",
    "Belvoir Capital AG":"Belvoir",
    "BennBridge Ltd":"BennBridge",
    "Bentley Capital Limited":"Bentley",
    "Beringea":"Beringea",
    "BFT Investment Managers":"BFT",
    "Big Society Capital Limited":"Big Society",
    "BIN YUAN CAPITAL":"BIN YUAN CAPITAL",
    "Birdie Fund Managers Ltd":"Birdie",
    "BK & JR Partnership":"BK & JR",
    "Blackfinch Investmentd Limited":"Blackfinch d",
    "Blackheath Capital Management LLP":"Blackheath",
    "BlackRock (Luxembourg) SA":"BlackRock",
    "BlackRock (Singapore) Limited":"BlackRock",
    "BlackRock Advisors (UK) Limited":"BlackRock",
    "BlackRock Advisors (UK) Limited - ETF":"BlackRock",
    "BlackRock Asset Management Deutschland AG - ETF":"BlackRock",
    "BlackRock Asset Management Ireland Ltd":"BlackRock",
    "BlackRock Capital Management Inc":"BlackRock",
    "BlackRock Financial Management Inc":"BlackRock",
    "Blackrock Financial Management, Inc":"Blackrock",
    "BlackRock Fund Advisors":"BlackRock",
    "BlackRock Fund Managers Limited":"BlackRock",
    "BlackRock Institutional Trust Company NA":"BlackRock",
    "Blackrock Inv Mgmt (Uk) Ltd":"Blackrock",
    "BlackRock Investment Management (UK) Ltd.":"BlackRock",
    "BlackRock Investment Management, LLC":"BlackRock",
    "Blackrock Investment Mgt(Dublin) Ltd":"Blackrock",
    "Blackstone / GSO Debt Funds Management Europe Limited":"Blackstone / GSO Debt",
    "Blackwall Capital Investment AG":"Blackwall",
    "BLI - Banque de Luxembourg Investments SA":"BLI Banque de",
    "Blu Family Office limited":"Blu Family Office limited",
    "Blue Planet Invest Mngmt Ltd (Malta)":"Blue Planet",
    "Blue Whale Capital LLP":"Blue Whale",
    "BlueBay Asset Management LLP":"BlueBay",
    "Bluefield Partners LLP":"Bluefield",
    "BlueOrchard Finance Ltd":"BlueOrchard Finance",
    "BMO AM Multi-Manager LLP":"BMO",
    "BMO Asset Management (Holdings) plc":"BMO",
    "BMO Asset Management Corp.":"BMO",
    "BMO Asset Management Limited":"BMO",
    "BMO Asset Management Netherlands B.V.":"BMO",
    "BMO Global Asset Management (GAM)":"BMO",
    "BMO Investment Business Ltd":"BMO",
    "BNP Paribas Asset Management Asia Limited":"BNP",
    "BNP Paribas Asset Management Belgium":"BNP",
    "BNP Paribas Asset Management Brasil Ltda":"BNP",
    "BNP Paribas Asset Management France":"BNP",
    "BNP Paribas Asset Management Luxembourg":"BNP",
    "BNP PARIBAS ASSET MANAGEMENT Nederland NV":"BNP",
    "BNP PARIBAS ASSET MANAGEMENT Netherlands N.V.":"BNP",
    "BNP Paribas Asset Management UK Limited":"BNP",
    "BNP Paribas Asset Management USA, Inc.":"BNP",
    "BNY Mellon Global Management Ltd":"BNY Mellon",
    "BNY Mellon Investment Adviser, Inc.":"BNY Mellon",
    "BNY Mellon Investment Management EMEA Limited":"BNY Mellon",
    "BNY Mellon Investment Management Japan Ltd":"BNY Mellon",
    "Bonafide Wealth Management AG":"Bonafide",
    "Bordier & Cie (UK) PLC":"Bordier",
    "Boston and Alexander LLP":"Boston and Alexander",
    "Boston Common Asset Management, LLC":"Boston Common",
    "Boston Financial Management, LLC":"Boston Financial",
    "Boussard & Gavaudan Gestion SAS":"Boussard & Gavaudan",
    "Boussard & Gavaudan Investment Management, LLP":"Boussard & Gavaudan",
    "BRAM – Bradesco Asset Management SA DTVM":"BRAM – Bradesco",
    "Bramshill Investments LLC":"Bramshill",
    "Brandeaux Advisers (UK) Ltd":"Brandeaux",
    "Brandes Investment Partners (Europe) Limited":"Brandes",
    "Brandywine Global Investment Mgmt, LLC":"Brandywine",
    "Brevan Howard Capital Management LP":"Brevan Howard",
    "Brewin Dolphin Ltd":"Brewin Dolphin",
    "British & American Investment Trust PLC":"British & American Inv Trust",
    "Brompton Asset Management Llp":"Brompton",
    "Brookfield Public Securities Group LLC":"Brookfield",
    "Brooks Macdonald Asset Management (IFSL)":"Brooks Macdonald",
    "Brooks Macdonald Asset Management (International) Limited":"Brooks Macdonald",
    "Brooks Macdonald Asset Management Ltd":"Brooks Macdonald",
    "Brooks Macdonald Funds Limited (IFSL)":"Brooks Macdonald",
    "Brown Advisory LLC":"Brown Advisory",
    "Brown Brothers Harriman & Co.":"Brown Brothers Harriman (BBH)",
    "Brown Brothers Harriman Mutual Fund Advisory Department":"Brown Brothers Harriman (BBH)",
    "Brown Shipley & Co Ltd":"Brown Shipley",
    "Brunel Pension Partnership Limited":"Brunel Pension",
    "Brunswick Investment Management Limited":"Brunswick",
    "BTG Pactual Asset Management SA DTVM":"BTG Pactual",
    "BTG Pactual Asset Management US, LLC":"BTG Pactual",
    "Butler Investment Managers Ltd":"Butler",
    "Byron Capital Partners Limited":"Byron",
    "CA Indosuez Wealth (Europe)":"CA Indosuez",
    "CAIAC Fund Management AG":"CAIAC",
    "Cairn Capital Limited":"Cairn",
    "Calamos Advisors LLC":"Calamos",
    "Calculus Capital Limited":"Calculus",
    "Caledonia Investments Plc":"Caledonia",
    "Cambium Global Timberland Ltd":"Cambium Global Timberland",
    "Cambridge Associates":"Cambridge",
    "Canaccord Genuity Wealth (Intl) Ltd":"Canaccord Genuity Intl",
    "Canaccord Genuity Wealth Limited":"Canaccord Genuity",
    "Canada Life Asset Management Limited":"Canada Life",
    "Canada Life International":"Canada Life",
    "Canada Life Investments":"Canada Life",
    "Candriam Belgium":"Candriam",
    "Candriam France":"Candriam",
    "Candriam Luxembourg S.C.A.":"Candriam",
    "Cantab Asset Management Limited":"Cantab",
    "Cantor Fitzgerald Europe":"Cantor Fitzgerald",
    "Cape Capital AG":"Cape",
    "Capita Financial Administrators Limited":"Capita Financial Administrators",
    "Capita Financial Managers Ltd":"Capita Financial",
    "Capital Four AIFM A/S":"Four AIFM A/S",
    "Capital Fund Management SA":"Capital",
    "Capital International (UK)":"Capital",
    "Capital Research & Management Company":"CapRe",
    "Capital Research and Management Company":"CapRe",
    "Cardales Chartered Surveyors":"Cardales Chartered Surveyors",
    "Carmignac Gestion":"Carmignac",
    "Carmignac Gestion Luxembourg S.A.":"Carmignac",
    "Casteel Capital LLP":"Casteel",
    "Castellain Capital LLP":"Castellain",
    "Castlebay Investment Partners LLP":"Castlebay",
    "Castlefield Fund Partners Limited":"Castlefield",
    "Castlefield Investment Partners LLP":"Castlefield",
    "Catalyst Fund Managers (Pty) Limited":"Catalyst",
    "Causeway Capital Management LLC":"Causeway",
    "Causeway Securities Limited":"Causeway Securities",
    "Cavendish Asset Management Ltd":"Cavendish",
    "Cazenove Fund Management Ltd":"Cazenove",
    "CCLA Investment Management Ltd":"CCLA",
    "CCS Trustees Limited":"CCS Trustees",
    "Centre Asset Management,LLC":"Centre",
    "Cerno Capital Partners LLP":"Cerno Capital",
    "CG Asset Management Ltd":"CG Asset Management",
    "Charles Schwab Investment Management Inc":"Charles Schwab",
    "Charles Stanley & Co Ltd":"Charles Stanley",
    "Charteris Treasury Portfolio Mngrs Ltd":"Charteris",
    "Chawton Global Investors LLP":"Chawton",
    "Chelverton Asset Management Ltd":"Chelverton",
    "Chenavari Credit Partners LLP":"Chenavari Credit",
    "Cheviot Asset Management Limited":"Cheviot",
    "Cheviot Investment Limited":"Cheviot",
    "Cheyne Capital Management (UK) LLP":"Cheyne",
    "China Asset Management Co. Ltd. Beijing":"China AM",
    "China Post Global (UK) Limited":"China Post",
    "Chiron Investment Management, LLC":"Chiron",
    "Church House Investments":"Church House",
    "Church House Investments Ltd":"Church House",
    "CIAM":"CIAM",
    "CIFC Asset Management LLC":"CIFC",
    "CIS Unit Managers Ltd (Co-operative)":"CIS Unit Cooperative",
    "Cité Gestion SA":"Cité",
    "Citibank N.A. London Branch":"Citi",
    "Citigroup First Investment Mgt Ltd":"Citi",
    "Citigroup Global Markets Limited":"Citi",
    "City Financial Investment Company Ltd":"City Financial",
    "City of London Investment Mngmt Co. Ltd":"City of London",
    "Civitas Housing Advisors Limited":"Civitas Housing",
    "Clarion Investment Management Ltd":"Clarion",
    "Clear Peak Capital LLP":"Clear Peak",
    "Clearance Capital LLP":"Clearance",
    "ClearBridge Investments, LLC":"ClearBridge",
    "ClearBridge Investments, LLC.":"ClearBridge",
    "ClearBridge RARE Infrastructure Pty Ltd":"ClearBridge RARE Infrastructure",
    "Close Asset Management 53 Limited":"Close",
    "Close Asset Management Limited":"Close",
    "Close International Asset Management Ltd":"Close",
    "CM Investment Solutions Limited":"CM",
    "CMI Asset Management (Luxembourg) SA":"CMI",
    "CMI Fund Managers (IOM) Ltd":"CMI IOM",
    "Cobas Asset Management SGIIC S.A.":"Cobas",
    "Cogent Asset Management Ltd.":"Cogent",
    "Cohen & Steers Capital Management, Inc.":"Cohen & Steers",
    "Cohen & Steers UK Limited":"Cohen & Steers",
    "Colchester Global Investors Ltd":"Colchester",
    "Colonial First State Investments Limited":"Colonial First State",
    "Columbia Mgmt Investment Advisers, LLC":"Columbia",
    "Comgest Asset Management Intl Ltd":"Comgest",
    "Commerzbank AG":"Commerzbank",
    "Compass Group LLC":"Compass",
    "Consistent Unit Trust Management Ltd":"Consistent",
    "Contour Asset Management LLC":"Contour",
    "Conviction Equities Limited":"Conviction Equities",
    "Co-operative Asset Management Ltd":"Cooperative",
    "Coriolis Capital Limited":"Coriolis",
    "Cornelian Asset Managers Ltd":"Cornelian",
    "Coronation Asset Management (PTY) Ltd":"Coronation",
    "Coronation International Limited":"Coronation",
    "Coupland Cardiff Asset Management LLP":"Coupland Cardiff",
    "COURTIERS Asset Management Ltd":"COURTIERS",
    "COURTIERS Investment Services Limited":"COURTIERS",
    "Coutts & Co.":"Coutts",
    "Cowen Investment Advisors LLC":"Cowen",
    "CPR Asset Management":"CPR",
    "CQS (UK) LLP":"CQS",
    "CQS Cayman Limited Partnership":"CQS",
    "Crabel Capital Management LLC":"Crabel",
    "Cramer Rosenthal McGlynn LLC":"Cramer Rosenthal McGlynn",
    "Craton Capital Limited":"Craton",
    "Credit Suisse (Hong Kong) Limited":"Credit Suisse",
    "Credit Suisse (UK) Limited":"Credit Suisse",
    "Credit Suisse AG":"Credit Suisse",
    "Credit Suisse Asset Management (Schweiz) AG":"Credit Suisse",
    "Credit Suisse Asset Management KAG mbH":"Credit Suisse",
    "Credit Suisse Asset Management Ltd":"Credit Suisse",
    "Credit Suisse Asset Management, LLC":"Credit Suisse",
    "Credit Suisse HongKong Ltd":"Credit Suisse",
    "Credit Suisse Insurance Linked Strategies Ltd, Zurich":"Credit Suisse",
    "Credit Suisse International":"Credit Suisse",
    "Credit Suisse Investment Partners (Switzerland) Ltd":"Credit Suisse",
    "Credo Capital Limited":"Credo",
    "Crescent Capital Group L.P.":"Crescent",
    "Crossinvest SA":"Crossinvest",
    "Crux Asset Management Limited":"Crux",
    "Crystal Amber Asset Mgmt (Guernsey) Ltd":"Crystal Amber",
    "Cullen Capital Management, LLC":"Cullen",
    "Culross Global Management Ltd":"Culross",
    "Custodian Capital Ltd":"Custodian",
    "CVC Credit Partners":"CVC Credit",
    "Cygnus Asset Management SGIIC S.A.":"Cygnus",
    "Da Vinci Capital Management Limited":"Da Vinci",
    "Dalton Investments LLC":"Dalton",
    "Dalton Strategic Partnership LLP":"Dalton Strategic",
    "Dalton, Greiner, Hartman, Maher & Co., LLC":"Dalton Greiner Hartman Maher",
    "Danske Bank A/S":"Danske Bank A/S",
    "Dasym Managed Accounts B.V":"Dasym Managed Accounts BV",
    "Davy Asset Management Limited":"Davy",
    "Davy Global Fund Management Limited":"Davy",
    "DB UK Bank Ltd":"DB Bank",
    "DCI, LLC":"DCI",
    "DDJ Capital Management, LLC":"DDJ",
    "De Lisle Partners LLP":"De Lisle",
    "Degroof Petercam Asset Management S.A.":"Degroof Petercam",
    "Deka Investment GmbH":"Deka",
    "Deutsche Asset & Wealth Management Investment GmbH":"Deutsche",
    "Deutsche Bank (Suisse) SA":"Deutsche Bank",
    "Deutsche Bank AG":"Deutsche Bank",
    "Devon Equity Management Limited":"Devon Equity",
    "Diamond Capital Management (Singapore) Pte Ltd":"Diamond",
    "Dimensional Fund Advisors Ltd":"Dimensional",
    "Discretionary Unit Fund Managers":"Discretionary",
    "DIVAS Asset Management AG":"DIVAS",
    "DJE Kapital AG":"DJE Kapital",
    "DNB Asset Management AS":"DNB AS",
    "DNCA Finance":"DNCA Finance",
    "Dodge & Cox":"Dodge & Cox",
    "Doherty PIC Ltd (DPIC)":"Doherty PIC DPIC",
    "Dolan Mceniry Capital Management LLC":"Dolan Mceniry",
    "Dolphin Capital Partners Ltd":"Dolphin",
    "Dominicé & Co Asset Management":"Dominicé & Co",
    "Dominion Fund Management Ltd":"Dominion",
    "Dominion Risk Management SA":"Dominion",
    "Doric GmbH":"Doric",
    "Dorval Asset Management":"Dorval",
    "Downing":"Downing",
    "Downing Corporate Finance":"Downing",
    "Downing LLP":"Downing",
    "Driehaus Capital Management LLC":"Driehaus",
    "Drum REIT LLP":"Drum REIT",
    "Drumz plc":"Drumz",
    "DS Aviation GmbH & Co. KG":"DS Aviation & KG",
    "DSM Capital Partners LLC":"DSM",
    "Dundas Partners LLP":"Dundas",
    "Dunedin LLP":"Dunedin",
    "Dupont Capital Management Corporation":"Dupont",
    "DWS Finanz-Service GmbH":"DWS",
    "DWS International GmbH":"DWS",
    "DWS Investment GmbH":"DWS",
    "DWS Investment S.A.":"DWS",
    "DWS Investments Hong Kong Limited":"DWS",
    "DWS Investments Singapore Limited":"DWS",
    "DWS Investments UK Limited":"DWS",
    "Dynam Capital Ltd":"Dynam",
    "Dynamic Beta investments LLC":"Dynamic Beta investments",
    "E.I. Sturdza Strategic Management Ltd":"EI Sturdza Strategic",
    "Eagle Capital Management, LLC":"Eagle",
    "East Capital Asset Management S.A.":"East",
    "Eastspring Investments (Singapore) Ltd":"Eastspring",
    "Eaton Vance Management":"Eaton Vance",
    "Ecofin":"Ecofin",
    "EdenTree Investment Management Limited":"EdenTree",
    "Edge Investment Management Limited":"Edge",
    "Edgewood Management LLC":"Edgewood",
    "Edinburgh Partners Limited":"Edinburgh",
    "Ediston Investment Services Limited":"Ediston",
    "Edmond de Rothschild (Suisse) SA":"Edmond de Rothschild",
    "Edmond de Rothschild Asset Management (France)":"Edmond de Rothschild",
    "EFG Asset Management (Switzerland) SA":"EFG",
    "EFG Asset Management (UK) Ltd":"EFG",
    "EFG Private Bank Limited":"EFG",
    "Egerton Capital (UK) LLP":"Egerton",
    "EII Capital Management, Inc":"EII",
    "Ekins Guinness LLP":"Ekins Guinness",
    "Elara Asset Management Ltd.":"Elara",
    "Elderstreet Investments Limited":"Elderstreet",
    "Electra Partners":"Electra",
    "Eleva Capital S.A.S.":"Eleva",
    "Embeth Williams Capital Ltd":"Embeth Williams",
    "Emso Partners Limited":"Emso",
    "Ennismore Fund Management Limited":"Ennismore",
    "Enterprise Investment Management Ltd":"Enterprise",
    "EnTrust Global Ltd.":"EnTrust",
    "Epicure Managers Qatar Limited":"Epicure Qatar",
    "Epoch Investment Partners Inc":"Epoch",
    "Epworth Investment Management Ltd":"Epworth",
    "Equilibrium Investment Management LLP":"Equilibrium",
    "Equitile Investments Ltd":"Equitile",
    "Equity Trustees Fund Services (Ireland) Ltd":"Equity Trustees",
    "Equity Trustees Fund Services Ltd":"Equity Trustees",
    "ERIM LLP":"ERIM",
    "ETFS Management Company (Jersey) Limited":"ETFS",
    "Ethical Capital Opportunity Advisors Ltd":"Ethical Capital Opportunity",
    "Eurizon Capital SGR SpA":"Eurizon SGR SpA",
    "Evenlode Investment Management Limited":"Evenlode",
    "Exane Asset Management":"Exane",
    "F&C Managers Limited":"F&C",
    "FACET":"FACET",
    "Fair Oaks Capital Limited":"Fair Oaks",
    "Fairpointe Capital LLC":"Fairpointe",
    "Fairtree Asset Management (Pty) Ltd.":"Fairtree",
    "FCM Salamanca LLP":"FCM Salamanca",
    "Federated Global Investment Management Corp":"Federated Corp",
    "Federated Hermes (UK) LLP":"Hermes",
    "Federated Investment Counseling":"Federated Counseling",
    "Fenician Capital Management LLP":"Fenician",
    "Fermat Capital Mgt LLC":"Fermat",
    "Ferox Capital LLP":"Ferox",
    "FF&P Asset Management Limited":"FF&P",
    "Fidante Partners Europe Limited":"Fidante",
    "Fidelity (FIL Fund Management Limited)":"Fidelity (FIL)",
    "Fidelity (FIL Investment SVCS (UK) Ltd)":"Fidelity (FIL)",
    "Fidelity Investment Services Ltd":"Fidelity",
    "Fiera Capital (IOM) Limited":"Fiera",
    "Fiera Capital (UK) Limited":"Fiera",
    "Fiera Capital Corporation":"Fiera",
    "FIL (Luxembourg) SA":"Fidelity (FIL)",
    "FIL Fund Management Limited":"Fidelity (FIL)",
    "FIL Investment Management (HK) Ltd":"Fidelity (FIL)",
    "FIL Investment Management (Singapore)Ltd":"Fidelity (FIL)",
    "FIL Investment Services (UK) Ltd":"Fidelity (FIL)",
    "FIL Investments (Japan) Limited":"Fidelity (FIL)",
    "FIL Investments International":"Fidelity (FIL)",
    "FIL Pensions Management":"Fidelity (FIL)",
    "FIM Partners UK Ltd":"FIM",
    "Finaltis":"Finaltis",
    "Findlay Park Partners LLP":"Findlay Park",
    "FinEx Capital Management LLP":"FinEx",
    "Finexis S.A.":"Finexis",
    "FinLabo SIM S.P.A.":"FinLabo SIM SPA",
    "First Eagle Investment Management, LLC":"First Eagle",
    "First Sentier Investors (Hong Kong) Limited":"First Sentier",
    "First Sentier Investors (UK) Funds Ltd":"First Sentier",
    "First Sentier Investors (UK) IM Limited":"First Sentier",
    "First State Investments International Limited":"First State",
    "First Trust Advisors L.P.":"First Trust",
    "Fischer Francis Trees & Watts, Inc":"Fischer Francis Trees & Watts",
    "Fisher Investments":"Fisher Investments",
    "Fisher Investments CA":"Fisher Investments",
    "Fisher Investments Europe Limited":"Fisher Investments",
    "Flossbach von Storch AG":"Flossbach von Storch",
    "Foord Asset Management (Guernsey) Limited":"Foord",
    "Foresight Group CI Limited":"Foresight",
    "Foresight Group LLP":"Foresight",
    "FORT LP":"FORT",
    "Forte Securities Limited":"Forte Securities",
    "Fortem Capital Limited":"Fortem",
    "Fortress Investment Group LLC":"Fortress",
    "Foundation Investment Management Ltd":"Foundation",
    "FPP Asset Management LLP":"FPP",
    "Framont & Partners Management Ltd":"Framont",
    "Franklin Advisers, Inc.":"Franklin",
    "Franklin Advisory Services, LLC":"Franklin",
    "Franklin Mutual Advisers, LLC":"Franklin Mutual",
    "Franklin Templeton Fund Management Ltd":"Franklin Templeton",
    "Franklin Templeton Institutional, LLC":"Franklin Templeton",
    "Franklin Templeton International Services S.à r.l.":"Franklin Templeton",
    "Franklin Templeton Inv Mgmt Ltd":"Franklin Templeton",
    "Franklin Templeton Investment Funds":"Franklin Templeton",
    "Franklin Templeton Investment Management":"Franklin Templeton",
    "Franklin Templeton Investment Mngt Ltd":"Franklin Templeton",
    "FRANKLIN TEMPLETON INVESTMENTS (ASIA) LIMITED":"Franklin Templeton",
    "Franklin Templeton Investments (ME) Limited":"Franklin Templeton",
    "Franklin Templeton Investments Asia Ltd":"Franklin Templeton",
    "Franklin Templeton Investments Corp":"Franklin Templeton",
    "Freedom Asset Management Limited":"Freedom",
    "Friends Life Funds Limited":"Friends Life",
    "Frontier Capital Management LLP":"Frontier",
    "Fulcrum Asset Management LLP":"Fulcrum",
    "Fullgoal Asset Management (HK) Ltd.":"Fullgoal",
    "Funding Circle Ltd":"ing Circle",
    "FundLogic":"FundLogic",
    "Fundlogic SAS":"logic",
    "FundPartner Solutions (Europe) S.A.":"FundPartner Solutions",
    "Fundsmith Investment Services Limited":"Fundsmith",
    "Fundsmith LLP":"Fundsmith",
    "Fusion Wealth Limited":"Fusion",
    "Future Money Ltd":"Future Money",
    "Gabelli Funds LLC":"Gabelli",
    "GAM (Italia) SGR SpA":"GAM",
    "GAM Fd Mgt (Ireland)":"GAM",
    "GAM International Management Limited":"GAM",
    "GAM Investment Management (Switzerland) AG":"GAM",
    "GAM London Limited":"GAM",
    "GAM Systematic LLP":"GAM",
    "Gam USA Inc":"Gam",
    "Garraway Capital Management LLP":"Garraway",
    "GaveKal Capital Limited":"GaveKal",
    "Generali Investments Partners S.p.A. SGR":"Generali",
    "Generali Portfolio Mgt (CI) Ltd(Link)":"Generali",
    "Generation Investment Management LLP":"Generation",
    "Genesis Investment Management, LLP":"Genesis",
    "Geode Capital Management, LLC":"Geode",
    "Gerrard Investment Management Limted":"Gerrard Limted",
    "GFG Groupe Financier de Gestion (Monaco) SAM":"GFG e Financier de M",
    "GH Fund Management Corporation":"GH",
    "GHC Fund Management Limited":"GHC",
    "GLG Partners LP":"GLG",
    "GLG Partners UK Limited":"GLG",
    "GLG,LLC":"GLG",
    "Global Evolution Fondsmæglerselskab A/S":"Evolution Fondsmæglerselskab A/S",
    "Global Systematic Investors LLP":"Global Systematic",
    "Global Thematic Partners, LLC":"Global Thematic",
    "Global X Management Company LLC":"Global X",
    "GO ETF Solutions LLP":"GO ETF",
    "Goldman Sachs Asset Management International":"Goldman Sachs",
    "Goldman Sachs International":"Goldman Sachs",
    "Goldman Sachs International (London)":"Goldman Sachs",
    "Goodhart Partners LLP (GB)":"Goodhart GB",
    "Gore Street Capital Limited":"Gore Street",
    "GQG Partners LLC":"GQG",
    "Graham Capital Management LP":"Graham",
    "Granahan Investment Management Inc":"Granahan",
    "Granite M.S.A Ltd":"Granite MSA",
    "Grantham, Mayo, Van Otterloo & Co., LLC":"Grantham Mayo Van Otterloo",
    "Gravis Capital Management Limited":"Gravis",
    "Green Ash Partners LLP":"Green Ash",
    "Greencoat Capital LLP":"Greencoat",
    "Gresham House Asset Management Ltd":"Gresham House",
    "GuardCap Asset Management Limited":"GuardCap",
    "Guinness Asset Management Limited":"Guinness",
    "GVC Gaesco Gestión SGIIC":"GVC Gaesco Gestión",
    "GVQ Investment Management Limited":"GVQ",
    "H2O Asset Management L.L.P.":"H2O L",
    "Hamon Asset Management Ltd":"Hamon",
    "Handelsbanken Fonder AB":"Handelsbanken Fonder AB",
    "Handelsbanken Wealth & Asset Management Limited":"Handelsbanken",
    "Hansa Capital Partners LLP":"Hansa",
    "Harbourvest Partners LLC":"Harbourvest",
    "Hargreave Hale Limited":"Hargreave Hale",
    "Hargreaves Lansdown Fund Managers Ltd":"Hargreaves Lansdown",
    "Harmony Capital Investors Limited":"Harmony",
    "Harris Associates L.P.":"Harris",
    "Harvest Global Investments Limited":"Harvest",
    "Harwood Capital LLP":"Harwood",
    "Harwood Capital Management Ltd":"Harwood",
    "Hathaway Investment Management Limited":"Hathaway",
    "Havelock London Limited":"Havelock London",
    "Hawksmoor Investment Management":"Hawksmoor",
    "HBM Partners AG":"HBM",
    "HBM Partners Cayman Ltd":"HBM",
    "Hearthstone Asset Management Limited":"Hearthstone",
    "Heartwood Wealth Management Limited":"Heartwood",
    "Hedge Invest SGR PA":"Hedge SGR PA",
    "Heitman Real Estate Securities LLC":"Heitman Real Estate Securities",
    "Henderson Global Investors Ltd":"Henderson",
    "Henderson Investment Funds Ltd":"Henderson",
    "Henderson Management SA":"Henderson",
    "Henderson Rowe Limited":"Henderson",
    "Heptagon Capital Limited":"Heptagon",
    "Herald Investment Management Limited":"Herald",
    "Heritage Capital Management Ltd (UK)":"Heritage",
    "Hermes Investment Management Ltd":"Hermes",
    "Heronbridge Investment Management LLP":"Heronbridge",
    "Heward Investment Management Inc":"Heward",
    "Hexavest Inc":"Hexavest",
    "Hg Pooled Management Limited":"Hg Pooled",
    "Highbridge Capital Management (UK) Ltd":"Highbridge",
    "Holinger Asset Management AG":"Holinger",
    "Hollis Capital Limited":"Hollis",
    "Horizons ETFs Management (Canada) Inc":"Horizons ETFs",
    "Hotchkis & Wiley Capital Management LLC":"Hotchkis & Wiley",
    "HSBC Alternative Investments Limited":"HSBC",
    "HSBC Global AM (México) SA de CV":"HSBC",
    "HSBC Global Asset Management (France)":"HSBC",
    "HSBC Global Asset Management (HK) Ltd":"HSBC",
    "HSBC Global Asset Management (UK) Ltd":"HSBC",
    "HSBC Global Asset Management (USA) Inc.":"HSBC",
    "HSBC Life Europe":"HSBC",
    "HSBC Portfoy Yonetimi A.S":"HSBC",
    "Hutchinson Lilley Investments Ltd":"Hutchinson Lilley",
    "Hyposwiss Private Bank Genève SA":"Hyposwiss Private Bank Genève",
    "IBOSS Asset Management Ltd":"IBOSS",
    "ICBC Credit Suisse Asst Mgt(Intl)Co Ltd":"Credit Suisse",
    "ICF Management Limited":"ICF",
    "ICG Alternative Investment Limited":"ICG Alternative",
    "ICM Investment Management Limited":"ICM",
    "ICM Ltd.":"ICM",
    "iFunds Asset Management Limited":"iFunds",
    "Ignis Asset Mgmt":"Ignis",
    "Ignis Investment Services Ltd":"Ignis",
    "IIFL Capital Pte Ltd":"IIFL",
    "IM Asset Management":"IM",
    "Impact health Partners LLP":"Impact health",
    "Impax Asset Management Ltd":"Impax",
    "Income Partners Asset Management (HK)Ltd":"Income Partners",
    "Independent Investment Group":"Independent",
    "Inflection Point Investments LLP":"Inflection Point",
    "InfraRed Capital Partners Ltd":"InfraRed",
    "Infusive Asset Management Inc":"Infusive",
    "Innocap Global Investment Management (Ireland) Ltd":"Innocap",
    "Insight Investment Funds Management Limited":"Insight",
    "Insight Investment Mgmt (Global) Ltd":"Insight",
    "Intermede Investment Partners Ltd":"Intermede",
    "Intermediate Capital Managers Limited":"Intermediate",
    "International Value Advisers, LLC":"International Value",
    "Intrinsic Value Investors (IVI) LLP,":"Intrinsic Value",
    "Invesco Advisers, Inc":"Invesco",
    "Invesco Advisers, Inc.":"Invesco",
    "Invesco Asset Management Deutschland GmbH":"Invesco",
    "Invesco Asset Management Ltd":"Invesco",
    "Invesco Capital Management LLC":"Invesco",
    "Invesco Fund Managers Limited":"Invesco",
    "Invesco Hong Kong Limited":"Invesco",
    "Invesco PowerShares Capital Management LLC":"Invesco",
    "Investcorp Investment Advisers LLC":"Investcorp",
    "Investec Securities (Proprietary) Limited":"Investec",
    "Investec Wealth & Investment Limited":"Investec",
    "Investec Wealth & Investment Ltd":"Investec",
    "Ireka Development Management Sdn Bhd":"Ireka Development",
    "Iridian Asset Management LLC":"Iridian",
    "Irish Life":"Irish Life",
    "Irish Life Investment Managers Limited":"Irish Life",
    "J O Hambro Capital Management Limited":"JO Hambro",
    "J O Hambro Investment Management Ltd":"JO Hambro",
    "J Rothschild Capital Management Limited":"J Rothschild",
    "J&E Davy":"J&E Davy",
    "J. Safra Sarasin Asset Management (Europe) Ltd":"Safra Sarasin",
    "J. Stern & Co. LLP":"J Stern",
    "J.Chahine Capital":"JChahine",
    "J.P. Morgan Bank Luxembourg S.A.":"JP Morgan",
    "J.P. Morgan Investment Management, Inc.":"JP Morgan",
    "J8 Capital Management LLP, London":"J8",
    "Jacobs Levy Equity Management, Inc.":"Jacobs Levy Equity",
    "Jaguar Listed Property LLC":"Jaguar Listed Property",
    "James Hambro & Partners LLP":"James Hambro",
    "Janus Capital International Ltd":"Janus",
    "Janus Henderson Group PLC":"Janus Henderson",
    "Janus Henderson Investors":"Janus Henderson",
    "Janus Henderson Investors Ltd":"Janus Henderson",
    "JF Asset Management Ltd":"JF",
    "JK Investment Management":"JK",
    "JM Finn & Co Ltd":"JM Finn & Co",
    "JM Finn & Company":"JM Finn",
    "JO Hambro Capital Management Limited":"JO Hambro",
    "Jordan / Zalaznick Advisors Inc":"Jordan / Zalaznick",
    "JP Morgan Alternative Asset Mgmt Inc":"JP Morgan",
    "JP Morgan Asset Management (UK) Ltd":"JP Morgan",
    "JP Morgan Investment Mgmt Inc":"JP Morgan",
    "JP Morgan Mansart Management Ltd":"JP Morgan",
    "JPM Asset Management (Singapore) Ltd":"JP Morgan",
    "JPMorgan Asset Management (Japan) Ltd":"JP Morgan",
    "JPMorgan Asset Management (UK) limited":"JP Morgan",
    "JPMorgan Asset Mgt Asia Pacific Limited":"JP Morgan",
    "JPMorgan Funds Limited":"JP Morgan",
    "Julius Baer International":"Julius Baer",
    "Jupiter Asset Management Limited":"Jupiter",
    "Jupiter Asset Management Ltd (UK)":"Jupiter",
    "Jupiter Investment Management Holdings Ltd":"Jupiter",
    "Jupiter Unit Trust Managers Ltd":"Jupiter",
    "Jyske Bank A/S":"Jyske Bank A/S",
    "K2/D&S Management Co., L.L.C.":"K2/D&S",
    "KBC Asset Management SA":"KBC",
    "KBI Global Investors Ltd":"KBI",
    "Keel Capital AB":"Keel AB",
    "Kempen Capital Management (UK) Ltd.":"Kempen",
    "Kempen Capital Management N.V.":"Kempen NV",
    "Kennox Asset Management Ltd":"Kennox",
    "Kepler Partners LLP":"Kepler",
    "Kestrel Partners LLP":"Kestrel",
    "Kirton Bank S.A. – Banco Múltiplo":"Kirton Bank – Banco Múltiplo",
    "Kite Lake Capital Management (UK) LLP":"Kite Lake",
    "KKV Investment Management Ltd":"KKV",
    "Kleinwort Benson Bank Limited":"Kleinwort Benson Bank",
    "KLS Diversified Asset Management LP":"KLS Diversified",
    "KMG Investment Management Limited":"KMG",
    "Korea Investment Management Co., Ltd":"Korea Investment Management",
    "Korea Investment Value Asset Management":"Korea Investment Value",
    "Kotak Mahindra (UK) Limited":"Kotak",
    "Kotak Mahindra Asset Management Co Ltd":"Kotak",
    "Krane Funds Advisors LLC":"Krane",
    "Kredietrust Luxembourg S.A.":"Kredietrust",
    "Kurm Capital Management Limited":"Kurm",
    "La Française Asset Management":"La Française",
    "Lannebo Fonder":"Lannebo Fonder",
    "LarrainVial Asset Management Administradora General de Fondos S.A.":"LarrainVial",
    "Latitude Investment Management LLP":"Latitude",
    "Lazard Asset Management (Deutschland) GmbH":"Lazard",
    "Lazard Asset Management LLC":"Lazard",
    "Lazard Asset Management Ltd":"Lazard",
    "Lazard Asset Management Pacific Co":"Lazard",
    "Lazard Japan Asset Management K.K":"Lazard",
    "Leadenhall Capital Partners LLP":"Leadenhall",
    "Legal & General Investment Management":"Legal & General",
    "Legal & general investment Management Ltd":"Legal & General",
    "Legal & General(Unit Trust Managers)Ltd":"Legal & General",
    "Lemanik Invest S.A.":"Lemanik",
    "LGM Investments Limited":"LGM",
    "LGT Capital Partners Ltd.":"LGT",
    "LGT Vestra LLP":"LGT Vestra",
    "Lightman Investment Management Limited":"Lightman",
    "Lindsell Train Ltd":"Lindsell Train",
    "Link Fund Manager Solutions (Ireland) Limited":"Link",
    "Link Fund Solutions Limited":"Link",
    "Liontrust Investment Partners LLP":"Liontrust",
    "Liontrust Multi-Asset Limited":"Liontrust",
    "Livermore Investments Group Ltd":"Livermore",
    "Lloyds Bank PLC":"Lloyds Bank",
    "Logan Circle Partners LP":"Logan Circle Partners",
    "Lombard Odier (Europe) S.A. UK Branch":"Lombard Odier",
    "Lombard Odier (Hong Kong) Limited":"Lombard Odier",
    "Lombard Odier Asset Management (EU) Ltd":"Lombard Odier",
    "Lombard Odier Asset Management USA Corp":"Lombard Odier",
    "Lombard Odier Asset Mgt (Switzerland) SA":"Lombard Odier",
    "London & Capital Asset Management Ltd":"London & Capital",
    "London Company of Virginia Co":"London Company of Virginia",
    "Longview Partners Ltd Partnership":"Longview",
    "Loomis Sayles & Company LP":"Loomis Sayles",
    "Lord North Street Limited":"Lord North Street",
    "Lord, Abbett & Co LLC":"Lord Abbett & Co",
    "Loudwater Investment Partners Ltd":"Loudwater",
    "Lowes Financial Management Limited":"Lowes Financial",
    "LRI Invest S.A.":"LRI",
    "Lumyna Investments Limited":"Lumyna",
    "LXI REIT Advisors Limited":"LXI REIT",
    "Lyrical Asset Management LP":"Lyrical",
    "Lyxor Asset Management":"Lyxor",
    "Lyxor Asset Management UK LLP":"Lyxor",
    "Lyxor International Asset Management S.A.S.":"Lyxor",
    "M & G Investment Management":"M&G",
    "M D Barnard & Co. Limited":"M D Barnard",
    "M&G ALTERNATIVE INVESTMENT MANAGEMENT LIMITED":"M&G",
    "M&G Investment Management Ltd.":"M&G",
    "M&L Capital Management":"M&L",
    "M7 Real Estate Ltd":"M7 Real Estate",
    "MacKay Shields LLC":"MacKay Shields",
    "Macquarie Investment Management Advisers":"Macquarie",
    "Macquarie Investment Management Austria Kapitalanlage AG":"Macquarie",
    "Macquarie Investment Management Europe S.A.":"Macquarie",
    "Macquarie Investment Mgmt Austria KAG":"Macquarie",
    "Magallanes Value Investors SGIIC":"Magallanes Value",
    "Magellan Asset Management Limited":"Magellan",
    "MainFirst Affiliated Fund Manager (Switzerland) AG":"MainFirst Affiliated",
    "MainFirst Affiliated Fund Managers (Deutschland) GmbH":"MainFirst Affiliated",
    "Maitland Institutional Services Ltd.":"Maitland",
    "Majedie Asset Management":"Majedie",
    "Majedie Asset Management Ltd":"Majedie",
    "Man Fund Management Limited":"Man",
    "Man Solutions Limited":"Man",
    "Manager Of Managers Inc":"Manager Of Managers",
    "Mansard Capital Management Ltd.":"Mansard",
    "Manulife Investment Management (Hong Kong) Limited":"Manulife",
    "Manulife Investment Management (Ireland) Limited":"Manulife",
    "Manulife Investment Management (US) LLC":"Manulife",
    "Maple-Brown Abbott Limited":"MapleBrown Abbott",
    "Marathon Asset Management LP":"Marathon",
    "Marble Point Credit Management LLC":"Marble Point Credit",
    "Margetts Fund Management Limited":"Margetts",
    "Markel CATCo Investment Management Ltd":"Markel CATCo",
    "Marlborough Fund Managers Limited":"Marlborough",
    "Marlborough International Management Limited":"Marlborough",
    "Marlborough Investment Management Ltd.":"Marlborough",
    "Marsh & Mclennan Companies, Inc.":"Marsh & Mclennan Companies",
    "Marshall Wace LLP":"Marshall Wace",
    "Marsham Investment Management LLP":"Marsham",
    "Martin Currie Investment Management Ltd":"Martin Currie",
    "Marwyn Investment Management LLP":"Marwyn",
    "Massachusetts Financial Services Company":"Massachusetts",
    "Matthews International Cap Mgmt LLc":"Matthews",
    "Mattioli Woods PLC":"Mattioli Woods",
    "Maven Capital Partners UK LLP":"Maven",
    "Maverick Capital Ltd":"Maverick",
    "Mayar Capital Management":"Mayar",
    "MC Square S.A.":"MC Square",
    "McInroy & Wood Ltd":"McInroy & Wood",
    "MDO Management Company S.A.":"MDO",
    "Mellon Investments Corporation":"Mellon",
    "Menhaden PLC":"Menhaden",
    "Mercer Global Investments Europe Limited":"Mercer",
    "Mercer Global Investments Management Ltd":"Mercer",
    "Merchant Capital Manager Limited":"Merchant",
    "Mercia Fund Management Limited":"Mercia",
    "Merian Global Investors (UK) Limited":"Merian",
    "Merrill Lynch International Solutions":"Merrill Lynch",
    "Merrill Lynch Portfolio Managers Limited":"Merrill Lynch",
    "MetLife":"MetLife",
    "MetLife Europe Ltd":"MetLife",
    "Métropole Gestion":"Métropole",
    "Metropolis Capital Limited,":"Metropolis",
    "MFM Mirante Fund Management S.A.":"MFM",
    "Middlefield International Limited":"Middlefield",
    "MidOcean Credit Fund Management, L.P":"MidOcean Credit",
    "Millbank Investment Managers Ltd":"Millbank",
    "Millburn Ridgefield Corporation":"Millburn Ridgefield",
    "Miller Howard Investments Inc":"Miller Howard",
    "Miller Value Partners, LLC":"Miller Value",
    "Minerva Money Management Limited":"Minerva Money",
    "Mirabaud Asset Management (France) S.A.S.":"Mirabaud",
    "Mirabaud Asset Management (Suisse) SA":"Mirabaud",
    "Mirabaud Asset Management Ltd":"Mirabaud",
    "Mirabella Financial Services LLP":"Mirabella",
    "Mirae Asset Global Investments (HK) Ltd":"Mirae",
    "Mirova":"Mirova",
    "Mirova US LLC":"Mirova",
    "Miton Asset Management Limited":"Miton",
    "MitonOptimal Jersey Limited":"Miton",
    "Mitsubishi UFJ Asset Management UK Ltd":"Mitsubishi UFJ",
    "Mitsubishi UFJ Kokusai Asst Mgmt Co.,Ltd":"Mitsubishi UFJ Kokusai Asst",
    "ML Capital Asset Management Limited":"ML",
    "Mobeus Equity Partners LLP":"Mobeus Equity",
    "Mobius Capital Partners LLP":"Mobius",
    "Momentum Global Investment Mgmt Ltd":"Momentum",
    "Mondrian Investment Partners Ltd":"Mondrian",
    "Moneda S.A. Administradora General de Fondos.":"Moneda",
    "Moneta Asset Management":"Moneta",
    "Montag & Caldwell, LLC":"Montag & Caldwell",
    "Montanaro Asset Management Limited":"Montanaro",
    "MontLake Management Limited":"MontLake",
    "Morant Wright Management Ltd":"Morant Wright",
    "Morgan Stanley Investment Management (ACD) Limited":"Morgan Stanley",
    "Morgan Stanley Investment Management Ltd":"Morgan Stanley",
    "Morgan Stanley Investment Management, Inc.":"Morgan Stanley",
    "Mori Capital Management Limited":"Mori",
    "Morningstar Investment Mgmt Europe Ltd.":"Morningstar",
    "MSS Capital Limited":"MSS",
    "Muzinich & Co Ltd":"Muzinich",
    "Nabarro LLP":"Nabarro",
    "Nanjia Capital Ltd":"Nanjia",
    "Natixis Investment Managers International":"Natixis",
    "NB Alternatives Advisers LLC":"NB Alternatives",
    "Nedgroup Investments (IOM) Ltd":"Nedgroup IOM",
    "Neuberger Berman Europe Ltd":"Neuberger Berman",
    "Neville James Fund Managers":"Neville James",
    "New City Investment Managers Ltd":"New City",
    "New Energy Solar Manager Pty Limited":"New Energy Solar",
    "New Europe Capital Limited":"New Europe Capital",
    "New Generation Advisors, LLC":"New Generation",
    "Newscape Capital Group Ltd":"Newscape",
    "Newton Investment Managemen":"Newton",
    "Newton Investment Management Ltd":"Newton",
    "NextEnergy Capital IM Limited":"NextEnergy IM",
    "Nezu Asia Capital Management Limited":"Nezu",
    "NFU Mutual Unit Managers Limited":"NFU Mutual Unit",
    "Nikko Asset Management Americas Inc":"Nikko",
    "Nikko Asset Management Asia Limited":"Nikko",
    "Nikko Asset Management Co Ltd":"Nikko Co",
    "Nikko Asset Management Europe Ltd":"Nikko",
    "Ninety One Hong Kong Limited":"Ninety One",
    "Ninety One UK Limited":"Ninety One",
    "Nippon Life India Asset Management (Singapore) Pte. Ltd.":"Nippon Life India",
    "NN Investment Partners (Singapore) Ltd":"NN",
    "NN Investment Partners BV":"NN",
    "NNIP Advisors B.V.":"NNIP",
    "Nomura Alternative Investment Management France S.A.S.":"Nomura",
    "Nomura Alternative Invt Mgnt (Eur) Ltd":"Nomura",
    "Nomura Asset Management U.K. Ltd":"Nomura",
    "Nordea Investment Management AB":"Nordea",
    "Nordkinn Asset Management":"Nordkinn",
    "North Capital Management Limited":"North",
    "North Investment Partners":"North",
    "Northern Trust Asset Management":"Northern Trust",
    "Northern Trust Fiduciary Services (Ireland) Limited":"Northern Trust",
    "Northern Trust Global Investments Ltd":"Northern Trust",
    "Northern Trust Investments Inc":"Northern Trust",
    "Notz, Stucki & Cie SA":"Notz Stucki",
    "Notz, Stucki Europe SA":"Notz Stucki",
    "Novacap Asset Management S.A.":"Novacap",
    "Numeric Investors LLC":"Numeric",
    "NUMERICA PARTNERS investment management Ltd.":"NUMERICA",
    "Nuveen Fund Advisors, LLC.":"Nuveen",
    "Nuveen Real Estate Management Limited":"Nuveen",
    "Oakley Capital Ltd":"Oakley",
    "Oaktree Capital Management (UK) LLP":"Oaktree",
    "Oaktree Capital Management LP":"Oaktree",
    "Oasis Crescent Capital (Pty) Ltd":"Oasis Crescent",
    "Ocean Dial Asset Management Limited":"Ocean Dial",
    "Octogone Europe S.A.":"Octogone",
    "Octopus Investments Limited":"Octopus",
    "Odd Asset Management Limited":"Odd",
    "ODDO BHF Asset Management GmbH":"ODDO BHF",
    "Odey Asset Management LLP":"Odey",
    "Odyssean Capital LLP":"Odyssean",
    "Old Mutual Investment Group (Pty) Limited":"Old Mutual",
    "Oldfield Partners LLP":"Oldfield",
    "OLIM Limited":"OLIM",
    "OMBA Advisory & Investments Ltd":"OMBA",
    "Open Door Investment Management Ltd.":"Open Door",
    "OPES Wealth Management":"OPES",
    "Optima Fund Management LLC":"Optima",
    "Optimal Capital Advisors, LLC":"Optimal",
    "Optimus Capital LLP":"Optimus",
    "Orbimed Capital LLC":"Orbimed",
    "Orbis Investment Management (Guernsey) Limited":"Orbis",
    "Orbis Investment Management Limited":"Orbis",
    "Orbit Investment Securities Services Plc, London":"Orbit",
    "Osmosis Investment Management UK Limited":"Osmosis",
    "OSSIAM":"OSSIAM",
    "Ostrum Asset Management":"Ostrum",
    "Ostrum Asset Management Asia Limited":"Ostrum",
    "Oxeye Capital Management":"Oxeye",
    "Oxford Technology Managers Ltd":"Oxford Technology",
    "P. Schoenfeld Asset Management LP":"P Schoenfeld",
    "Pacific Capital Partners Limited":"Pacific",
    "Pacific Investment Management Company, LLC":"PIMCO",
    "Palm Harbour Capital LLP":"Palm Harbour",
    "Pantheon Ventures (UK) LLP":"Pantheon Ventures",
    "Parametric Portfolio Associates LLC":"Parametric Portfolio",
    "Partners Group AG":"Partners Group",
    "Payden & Rygel":"Payden & Rygel",
    "Payden & Rygel Global Limited":"Payden & Rygel",
    "Pembroke Investment Managers LLP":"Pembroke",
    "Perinvest (UK) Limited":"Perinvest",
    "Pershing Square Capital Management, L.p.":"Pershing Square",
    "Petrus Advisers Ltd.":"Petrus",
    "PGIM, Inc":"PGIM",
    "Pharmakon Advisors L.P.":"Pharmakon",
    "Philip Hare & Associates LLP":"Philip Hare",
    "Phoenix Asset Management Partners":"Phoenix",
    "Pictet Alternative Advisors S.A.":"Pictet",
    "PICTET AM S.A.,":"Pictet",
    "Pictet Asset Management (Europe) SA":"Pictet",
    "Pictet Asset Management Ltd":"Pictet",
    "Pictet Asset Management S.A.":"Pictet",
    "PIMCO":"PIMCO",
    "PIMCO Deutschland GmbH - München":"PIMCO",
    "PIMCO Europe GmbH":"PIMCO",
    "PIMCO Europe Ltd":"PIMCO",
    "PIMCO LLC":"PIMCO",
    "PineBridge Investments Asia Limited":"PineBridge",
    "PineBridge Investments Europe Limited":"PineBridge",
    "PineBridge Investments Japan Co Ltd":"PineBridge",
    "PineBridge Investments LLC":"PineBridge",
    "Plain English Finance Limited":"Plain English Finance",
    "Platinum Capital Management Ltd":"Platinum",
    "Plurimi Wealth LLP":"Plurimi",
    "PMM Partners (UK) Ltd":"PMM",
    "Polar Capital LLP":"Polar Capital",
    "Polen Capital Management, LLC":"Polen",
    "Pollen Street Capital Ltd":"Pollen Street",
    "Polunin Capital Partners Ltd":"Polunin",
    "Portfolio & Pension Management Limited":"Portfolio & Pension",
    "PortfolioMetrix Asset Management Ltd.":"PortfolioMetrix",
    "Portland Hill Capital LLP":"Portland Hill",
    "PPM America, Inc.":"PPM America",
    "Premier Asset Management (Guernsey) Ltd":"Premier",
    "Premier Fund Managers Limited":"Premier",
    "Premier Portfolio Managers Limited":"Premier",
    "Prescient Investment Management (Pty) Limited":"Prescient",
    "Prestbury Investments LLP":"Prestbury",
    "Price Value Partners Limited":"Price Value Partners",
    "Principal Global Investors, LLC":"Principal",
    "Principal Islamic Asset Management Sdn. Bhd":"Principal",
    "Privium Fund Management (UK) Limited":"Privium",
    "Prosperity Capital Management (RF) Ltd":"Prosperity RF",
    "Prosperity Capital Management (UK) Ltd":"Prosperity",
    "Protean Capital LLP":"Protean",
    "Protected Asset TEP Fund PLC":"Protected TEP",
    "Prudential":"Prudential",
    "Prudential International Assurance":"Prudential",
    "Prusik Investment Management LLP":"Prusik",
    "PSigma Investment Management Limited":"PSigma",
    "Puma Investment Management Limited":"Puma",
    "Pure Capital SA":"Pure",
    "Purple Strategic Capital Limited":"Purple Strategic",
    "Purpose Investments Inc.":"Purpose",
    "Putnam Advisory Co LLC":"Putnam Co",
    "Putnam Advisory Company, LLC":"Putnam",
    "Pyrford International Ltd":"Pyrford International",
    "Pzena Investment Management, LLC":"Pzena",
    "QS Investors LLC":"QS",
    "Quaero Capital LLP":"Quaero",
    "Quaero Capital SA":"Quaero",
    "Quantica Capital AG":"Quantica",
    "Quilter Cheviot Ltd":"Quilter",
    "Quilter Investors Limited":"Quilter",
    "Quoniam Asset Management GmbH":"Quoniam",
    "Quorus Vermögensverwaltung AG":"Quorus Vermögensverwaltung",
    "RAM Active Investments SA":"RAM Active",
    "Ranger Alternative Management, L.P":"Ranger Alternative",
    "Ranmore Fund Management LTD":"Ranmore",
    "Rathbone Investment Management Limited":"Rathbone",
    "Rathbone Unit Trust Management Limited":"Rathbone",
    "Ravenscroft Investment Management":"Ravenscroft",
    "Raw Capital Partners Ltd":"Raw",
    "RBC Global Asset Management Inc.":"RBC",
    "RBS Collective Investment Funds Limited":"RBS Collective",
    "RC Brown Investment Management PLC":"RC Brown",
    "RDP Fund Management LLP":"RDP",
    "Red Gate Asset Management Company Limited":"Red Gate",
    "Reliance Wealth Management Limited":"Reliance",
    "ReSI Capital Management Limited":"ReSI",
    "Resolute Management Services, LLC":"Resolute",
    "Resona Asset Management Co., Ltd.":"Resona",
    "Revera Asset Management Limited":"Revera",
    "RIGL Holdings, LP":"RIGL Holdings",
    "Rising Sun Management Ltd":"Rising Sun",
    "River and Mercantile Asset Management":"River and Mercantile",
    "River and Mercantile Asset Mgmt LLP":"River and Mercantile",
    "River and Mercantile Investments Limited":"River and Mercantile",
    "River and Mercantile LLC":"River and Mercantile",
    "River Road Asset Management, LLC":"River Road",
    "Riverstone Investment Group LLC":"Riverstone",
    "RM Capital Markets Limited":"RM Markets",
    "Robeco Ins.Asset Management B.V":"Robeco",
    "Robeco Institutional Asset Mgmt BV":"Robeco",
    "Robert W. Baird & Co. Incorporated":"Robert W. Baird & Co",
    "Rockefeller & Co. LLC":"Rockefeller",
    "Rometsch & Moor Ltd":"Rometsch & Moor",
    "Rossie House Investment Management":"Rossie House",
    "Rothschild & Co Wealth Management UK Ltd":"Rothschild & Co",
    "Rothschild HDF Investment Adviser Ltd":"Rothschild HDF Adviser",
    "Rothschild Private Management Limited":"Rothschild Private",
    "Rothschild Wealth Mgmt (UK) Ltd(Capita)":"Rothschild Capita",
    "Roxbury Asset Management Limited":"Roxbury",
    "Royal London Asset Management Ltd":"Royal London",
    "Royal London Unit Trust Managers Ltd":"Royal London",
    "Royal Skandia":"Royal Skandia",
    "Royce & Associates, LP":"Royce",
    "RPM Risk & Portfolio Management AB":"RPM Risk & Portfolio AB",
    "RREEF America LLC":"RREEF America",
    "RTW Investments, LP":"RTW",
    "Rubrics Asset Management (Ireland) Limited":"Rubrics",
    "Ruffer AIFM Limited":"Ruffer",
    "Ruffer LLP":"Ruffer",
    "Russell Investment Management, LLC":"Russell",
    "Russell Investments Ireland Limited":"Russell Investments",
    "Russell Investments Limited":"Russell Investments",
    "RWC Asset Management LLP":"RWC",
    "RWC Partners Limited":"RWC",
    "S C Davies & Co Ltd":"S C Davies & Co",
    "S. W. Mitchell Capital LLP":"S W Mitchell",
    "Safra Asset Management Ltda":"Safra",
    "Saltus Partners LLP":"Saltus",
    "Samarang LLP":"Samarang",
    "Sand Aire Limited":"Sand Aire",
    "Sandbar Asset Management LLP":"Sandbar",
    "Sanditon Asset Management Limited":"Sanditon",
    "Sands Capital Management, LLC":"Sands",
    "Sanlam FOUR Investments UK Limited":"Sanlam",
    "Sanlam International Investment Ltd":"Sanlam",
    "Sanlam Investment Management (Pty) Limited":"Sanlam",
    "Sanlam Investments UK Limited":"Sanlam",
    "Sanlam Private Investments (UK) Limited":"Sanlam",
    "Santa Lucia Asset Management Pte. Ltd":"Santa Lucia",
    "Santander Asset Management (LUX) S.A.":"Santander",
    "Santander Asset Management UK Limited":"Santander",
    "Santander Unit Trust Managers Ltd":"Santander",
    "Saracen Fund Managers Ltd":"Saracen",
    "Sarasin & Partners LLP":"Sarasin",
    "Sarasin Investment Funds Ltd":"Sarasin",
    "Sarasin Investment Management Ltd":"Sarasin",
    "Savills Investment Management":"Savills",
    "Scharf Investments, LLC":"Scharf",
    "Schroder & Co Limited":"Schroder",
    "Schroder Invest Manag North America":"Schroder",
    "Schroder Investment Management (Europe) S.A. - niederlassung Deutschland":"Schroder",
    "Schroder Investment Management (Europe) S.A., German Branch":"Schroder",
    "Schroder Investment Management (Hong Kong) Limited":"Schroder",
    "Schroder Investment Management (Singapore) Ltd":"Schroder",
    "Schroder Investment Management (Switzerland) AG":"Schroder",
    "Schroder Investment Management Limited":"Schroder",
    "Schroder Investment Management North America Inc.":"Schroder",
    "Schroder Investment Management Switzerland AG":"Schroder",
    "Schroder Investment Mgmt (Japan) Ltd":"Schroder",
    "Schroder Investment Mgmt Hong Kong Ltd":"Schroder",
    "Schroder Investment Mgt(Switzerland)AG":"Schroder",
    "Schroder Real Estate Investment Management Ltd":"Schroder",
    "Schroder Unit Trusts Limited":"Schroder",
    "Schroders & Co. Ltd":"Schroders",
    "Scottish Investment Trust (The) PLC":"Scottish Investment Trust",
    "Scottish Life Investments":"Scottish Life",
    "Scottish Provident International Life As":"Scottish Provident Life As",
    "Scout Investments":"Scout",
    "Sector Investments Managers Ltd":"Sector",
    "Sectoral Asset Management Inc":"Sectoral",
    "Seeyond":"Seeyond",
    "SEI Investments Management Corp":"SEI",
    "Seilern Investment Management Ltd":"Seilern",
    "Select Equity Group LP":"Select Equity",
    "Seligson & Co Rahastoyhtiö Oyj":"Seligson & Co Rahastoyhtiö Oyj",
    "Selwood Asset Management LLP":"Selwood",
    "Semper Capital Management LP":"Semper",
    "Seneca Investment Managers Limited":"Seneca",
    "Seneca Partners Ltd":"Seneca",
    "Sequel Investments Limited":"Sequel",
    "Sequoia Investment Management Company":"Sequoia",
    "Seven Investment Management Limited":"Seven Investment Management (7IM)",
    "Seven Investment Management LLP":"Seven Investment Management (7IM)",
    "SG Kleinwort Hambros Bank Limited":"SG Kleinwort Hambros Bank",
    "Shard Capital AIFM LLP":"Shard AIFM",
    "Share Centre Ltd":"Share Centre",
    "Shenkman Capital Management Inc":"Shenkman",
    "Shore Capital and Corporate Limited":"Shore",
    "SIA Funds AG":"SIA",
    "Sigma PRS Managment Limited":"Sigma PRS Managment",
    "Signia Wealth Limited":"Signia",
    "Silvercrest Asset Management Group LLC":"Silvercrest",
    "Singer & Friedlander Inv Mgmt Ltd":"Singer & Friedlander",
    "Sirios Capital Management L P":"Sirios L P",
    "SKAGEN AS":"SKEN AS",
    "Skerritt Consultants Limited":"Skerritt Consultants",
    "SKY Harbor Capital Management, LLC":"SKY Harbor",
    "Sl Capital Partners LLP":"Sl",
    "Slater Investments Limited":"Slater Investments",
    "Smart Investment Management Limited":"Smart",
    "Smart Lenders Asset Management SAS":"Smart Lenders",
    "Smead Capital Management Inc":"Smead",
    "Smith & Williamson Fd Adm Ltd":"Smith & Williamson",
    "Smith & Williamson Inv Mgmt Ltd":"Smith & Williamson",
    "Smith & Williamson Investment Mgmt LLP":"Smith & Williamson",
    "Société Générale Private Banking Monaco":"Société Générale (socgen)",
    "Société Générale Private Wealth Management S.A.":"Société Générale (socgen)",
    "Solidum Partners AG":"Solidum",
    "Somerset Capital Management LLP":"Somerset",
    "Sonoma Partners Ltd":"Sonoma",
    "Sorbus Partners LLP":"Sorbus",
    "Southeastern Asset Management Inc":"Southeastern",
    "Sparinvest S.A.":"Sparinvest",
    "SPARX Asset Management Co Ltd":"SPARX",
    "Spixworth Asset Management Limited":"Spixworth",
    "Sprott Asset Management LP":"Sprott",
    "Square Mile Investment Services Limited":"Square Mile",
    "St James Place Group":"St James's Place",
    "St James's Place Group":"St James's Place",
    "St James's Place Unit Trust Group Ltd":"St James's Place",
    "St Peter Port Capital Ltd":"St Peter Port",
    "St. James's Place Group":"St James's Place",
    "St. James's Place International":"St James's Place",
    "St. James's Place Unit Trust Group Ltd":"St James's Place",
    "Stamford Associates Limited":"Stamford",
    "Standard Life Aberdeen PLC":"Standard Life Aberdeen",
    "Standard Life Assurance Company":"Standard Life Assurance",
    "Standard Life Investments":"Standard Life",
    "Standard Life Investments (Mutual Funds) Limited":"Standard Life",
    "Standard Life Investments Ltd.":"Standard Life",
    "Standard Life Wealth Limited":"Standard Life",
    "Stanhope Capital LLP":"Stanhope",
    "STANLIB Multi-Manager":"STANLIB",
    "Stanwahr S.à.r.l.":"Stanwahr Sàrl",
    "Starwood European Finance Partners Ltd":"Starwood",
    "State Street Global Advisors":"State Street",
    "State Street Global Advisors (Chicago)":"State Street",
    "State Street Global Advisors Ireland Ltd":"State Street",
    "State Street Global Advisors Ltd":"State Street",
    "Stenham Asset Management (UK) plc":"Stenham",
    "Sterling Investments Management Ltd":"Sterling",
    "Stewart Investors":"Stewart Investors",
    "Steyn Capital Management":"Steyn",
    "Stonehage Fleming Investment Management Limited":"Stonehage",
    "Stonehorn Global Partners Limited":"Stonehorn",
    "Stonewood Capital Proprietary Limited":"Stonewood Proprietary",
    "Storebrand Asset Management AS":"Storebrand AS",
    "Storm Capital Management AS":"Storm AS",
    "Strand Hanson Ltd":"Strand Hanson",
    "Stratton Street Capital LLP":"Stratton Street",
    "Sturgeon Ventures LLP":"Sturgeon Ventures",
    "Sumitomo Mitsui DS Asset Management (UK) Limited":"Sumitomo Mitsui",
    "Sumitomo Mitsui DS Asset Management Company, Limited":"Sumitomo Mitsui",
    "Sumitomo Mitsui Trust Bank, Limited":"Sumitomo Mitsui",
    "Sustainable Development Capital LLP":"Sustainable Development",
    "SV Life Sciences Managers LLP":"SV Life Sciences",
    "SVM Asset Management Ltd":"SVM",
    "Swiss ALP Asset Management GmbH":"Swiss ALP",
    "Swisspartners (Liechtenstein) AG":"Swisspartners",
    "Syncona Investment Management Limited":"Syncona",
    "Synvest":"Synvest",
    "Systematica Investments Limited":"Systematica",
    "SYZ Asset Management (Europe) Limited":"SYZ",
    "T. Bailey Asset Management Limited":"T. Bailey",
    "T. Bailey Fund Services Limited":"T. Bailey",
    "T. Rowe Price International Limited":"T. Rowe Price",
    "T. Rowe Price International Ltd":"T. Rowe Price",
    "Tabula Investment Management Limited":"Tabula",
    "Taler Asset Management (Gibraltar) Ltd":"Taler",
    "Tareno AG":"Tareno",
    "Target Fund Managers Limited":"Target",
    "Tatton Investment Management Limited":"Tatton",
    "Taube Hodson Stonex Partners Limited":"Taube Hodson Stonex",
    "Tavistock Wealth Limited":"Tavistock",
    "Taylor Young Investment Mgt Ltd (Capita)":"Taylor Young Capita",
    "TCA Advisors":"TCA",
    "TCW Investment Management Co LLC":"TCW Co",
    "TEB PORTFOY YONETIMI AS":"TEB PORTFOY YONETIMI AS",
    "Techinvest Limited":"Techinvest",
    "Tellsons Investors LLP":"Tellsons",
    "Templeton Asset Management Ltd":"Templeton",
    "Templeton Asset Management Ltd.":"Templeton",
    "Templeton Global Advisors Limited":"Templeton",
    "Templeton Investment Counsel LLC":"Templeton Counsel",
    "Temporis Capital LLP":"Temporis",
    "Tender Capital Limited":"Tender",
    "Tetragon Financial Management LP":"Tetragon Financial",
    "Teviot Partners LLP":"Teviot",
    "Thames River Capital LLP":"Thames River",
    "Thames River Multi-Capital LLP":"Thames River",
    "The Family (Music) Limited":"The Family Music",
    "The Hartford":"The Hartford",
    "The Local Shopping REIT PLC":"The Local Shopping REIT",
    "Theorema Advisors UK LLP":"Theorema",
    "Thesis Asset Management Ltd":"Thesis",
    "Thesis Asset Management PLC":"Thesis",
    "Thesis Unit Trust Management Limited":"Thesis",
    "ThinkCapital Asset Management B.V.":"Think",
    "Third Avenue Management LLC":"Third Avenue",
    "Third Point LLC":"Third Point",
    "Thistledown Investment Management Ltd":"Thistledown",
    "Thomas Miller Invmt (Isle of Man) Ltd":"Thomas Miller",
    "Thomaslloyd Glb Asset Mgmt (Amer) LLC":"Thomaslloyd",
    "Thomson Horstmann & Bryant Inc":"Thomson Horstmann & Bryant",
    "Thornbridge Investment Management LLP":"Thornbridge",
    "Thornburg Investment Management Inc":"Thornburg",
    "Threadneedle Asset Management Limited":"Threadneedle",
    "Threadneedle Fund Managers":"Threadneedle",
    "Threadneedle Management Luxembourg S.A.":"Threadneedle",
    "Tideway Investment Partners LLP":"Tideway",
    "Tier One Capital Ltd":"Tier One",
    "Tiger Royalties and Investment PLC":"Tiger",
    "Tikehau Investment Management Asia Pte Ltd":"Tikehau",
    "Tilney AM International Limited":"Tilney",
    "Tilney Discretionary Portfolio Management Limited":"Tilney",
    "Tilstone Partners Limited":"Tilstone",
    "TIME Investments":"TIME",
    "TOBAM SAS":"TOBAM",
    "Tokio Marine Asset Management Co Ltd":"Tokio Marine Co",
    "Toscafund Asset Management LLP":"Toscafund",
    "Tremblant Capital LP":"Tremblant",
    "TRG Management LP":"TRG",
    "Trilogy Global Advisors, LP":"Trilogy",
    "Trinity Partners AG":"Trinity",
    "Trinity Street Asset Management LLP":"Trinity Street",
    "Triodos Investment Management B.V.":"Triodos",
    "Triple Point Investment Management LLP":"Triple Point",
    "Tritax Management LLP":"Tritax",
    "Trium Capital LLP":"Trium",
    "Troy Asset Management Limited":"Troy",
    "True Potential Investments LLP":"True Potential",
    "TT International":"TT",
    "TT International Asset Management Ltd":"TT",
    "Tufton Oceanic Assets Ltd":"Tufton Oceanic s",
    "Twelve Capital AG":"Twelve",
    "Twenty First Capital":"Twenty First",
    "TwentyFour Asset Management LLP":"TwentyFour",
    "Two Sigma Advisers LP":"Two Sigma",
    "Tyndaris LLP":"Tyndaris",
    "UBAM International Services":"UBAM",
    "UBP Asset Management (Europe) S.A.":"Union Bancaire Privee (UBP)",
    "UBP Asset Management Asia Limited Hong Kong":"Union Bancaire Privee (UBP)",
    "UBS Asset Management (Americas) Inc":"UBS",
    "UBS Asset Management (Hong Kong) Limited":"UBS",
    "UBS Asset Management (Singapore) Ltd":"UBS",
    "UBS Asset Management (UK) Ltd":"UBS",
    "UBS Asset Management Switzerland AG":"UBS",
    "UBS Asset Mgmt, Basel and Zurich":"UBS",
    "UBS Group AG":"UBS",
    "UBS Hedge Fund Solutions LLC":"UBS",
    "UBS Switzerland AG":"UBS",
    "Unbiased Financial Group LLP":"Unbiased Financial",
    "Unicorn Asset Management Ltd":"Unicorn",
    "Unigestion SA":"Unigestion",
    "Union Bancaire Gestion Institutionnelle (France)":"Union Bancaire Institutionnelle",
    "Union Bancaire Privée Asset Mgmt Ltd":"Union Bancaire Privée",
    "Union Bancaire Privée, UBP SA":"Union Bancaire Privee (UBP)",
    "Union Investment Privatfonds GmbH":"Union Privatfonds",
    "Universal-Investment Luxembourg SA":"Universal",
    "Usonian Investments LLC":"Usonian",
    "UTI International (Singapore) Pvt. Ltd.":"UTI Pvt",
    "Utmost Worldwide Limited":"Utmost Worldwide",
    "Valori Asset Management S.A.":"Valori",
    "ValuAnalysis Ltd":"ValuAnalysis",
    "Value Partners Hong Kong Limited":"Value",
    "Valu-Trac Investment Management Limited":"Valu-Trac",
    "Van Eck Associates Corporation":"VanEck",
    "VanEck Asset Management B.V.":"VanEck",
    "Vanguard Global Advisors, LLC":"Vanguard",
    "Vanguard Group Inc":"Vanguard",
    "Vanneck Limited":"Vanneck",
    "Vantage Investment Management Ltd":"Vantage",
    "Vaughan Nelson Investment Management, LP":"Vaughan Nelson",
    "Veritas Asset Management LLP":"Veritas",
    "Veritas Investment Associates":"Veritas",
    "Veritas Investment Partners (UK) Limited":"Veritas",
    "Vermeer Investment Management Ltd":"Vermeer",
    "Verrazzano Capital":"Verrazzano",
    "Viasource Communications Inc":"Viasource Communications",
    "Victory Park Capital Advisors LLC":"Victory Park",
    "Vident Investment Advisory, LLC":"Vident",
    "VinaCapital Investment Management Ltd":"Vina",
    "VinaWealth Fund Management JSC":"Vina JSC",
    "Virgin Money Unit Trust Managers Ltd.":"Virgin Money",
    "Virtus Investment Advisers, Inc.":"Virtus",
    "Vontobel Asset Management AG":"Vontobel",
    "Voya Investment Management Co. LLC":"Voya",
    "Vulcan Value Partners, LLC":"Vulcan Value",
    "Waddell & Reed Investment Management Company":"Waddell & Reed",
    "Wadhwani Asset Management LLP":"Wadhwani",
    "Walter Scott & Partners Limited":"Walter Scott",
    "Warana Capital LLC":"Warana",
    "Wasatch Advisors Inc.":"Wasatch",
    "Waterfall Asset Management, LLC":"Waterfall",
    "Waverton Investment Management Ltd":"Waverton",
    "WAY Fund Managers Limited":"WAY Fund Managers",
    "Webb Capital Asset Management Ltd":"Webb",
    "Weiss Asset Management LLC":"Weiss",
    "Wellian Investment Solutions Limited":"Wellian",
    "Wellington Management Company LLP":"Wellington",
    "Wellington Management Funds (Cayman)":"Wellington",
    "Wellington Management Hong Kong Ltd":"Wellington",
    "Wellington Management International Ltd":"Wellington",
    "Wellington Management Singapore Pte Ltd":"Wellington",
    "Wells Capital Management Inc.":"Wells",
    "Wells Fargo Asset Management (International) Ltd":"Wells Fargo",
    "Wells Fargo Asset Management Luxembourg S.A.":"Wells Fargo",
    "Wells Fargo Funds Management LLC":"Wells Fargo",
    "Wesleyan Unit Trust Managers Limited":"Wesleyan",
    "Western Asset Management Company Limited – UK":"Western –",
    "Western Asset Management Company, LLC":"Western",
    "WH Ireland Ltd":"WH",
    "WHEB Asset Management LLP":"WHEB",
    "White Oak Capital Partners Pte. Ltd.":"White Oak",
    "Whitefoord LLP":"Whitefoord",
    "Whitehelm Capital Pty Limited":"Whitehelm",
    "Whitman Asset Management Limited":"Whitman",
    "William Blair Investment Management, LLC":"William Blair",
    "Williams de Broe Limited":"Williams de Broe",
    "Willis Towers Watson PLC":"Willis Towers Watson",
    "Willowbridge Associates Inc":"Willowbridge",
    "Windmill Hill Asset Management Limited":"Windmill Hill",
    "Winton Capital Management Ltd.":"Winton",
    "Wise Funds Limited":"Wise",
    "Witan Investment Services Limited":"Witan",
    "WM Capital Management Ltd.":"WM",
    "Woodford Investment Management LLP":"Woodford",
    "Woodford Investment Management Ltd":"Woodford",
    "WoodHill Asset Management LLP":"WoodHill",
    "Worsley Associates LLP":"Worsley",
    "Wren Investment Office Limited":"Wren Office",
    "YFM Private Equity Limited":"YFM",
    "YFM Venture Finance Limited":"YFM",
    "York UCITS Holdings, LLC":"York UCITS Holdings",
    "Zadig Asset Management S.A.":"Zadig",
    "Zadig Gestion (Luxembourg) S.A.":"Zadig",
    "Zazove Associates, L.L.C.":"Zazove",
    "Zeal Asset Management Limited":"Zeal",
    "Zurich International Life Limited":"Zurich",
}


export function getCat(id){
    return cats[id]
}

export function getFreq(id){
    return freq[id]
}


export const legal = {
    "SICAV" : "SICAV",
    "Unit Trust"  : "UT",
    "Closed Ended Investment Company" :	"IT",
    "Open Ended Investment Company" :	"OEIC",
    "Collateralized Debt Instrument" : "CDI",
    "Uncollateralized Debt Instrument" : "UDI",
}

export function getLegal(id){
    return legal[id]
}

export function getShort(id){
    if (short.hasOwnProperty(id)){
        return short[id]
    }
    else{
        return id
    }
}

export function currency(currency, q){
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        currency
    }).format(q)
}
